var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1600 1066",
    width: 1280,
    height: 1280,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(593,99)",
    d: "m0 0 3 1 12 25 3 1 2-4 7-3 22-5 33-4 4-1 26-1h29l17 1 4 1 25 2 23 4 28 7 16 5 29 11 20 9 25 13 15 9 16 11 12 8 16 13 10 8 12 12 7 6 7 8 14 14 9 11 13 17 10 14 11 18 8 13 4 8 1 6h87l168-1h55l8 4 6 8 1 3v25l-1 16-1 71-2 66-1 62-2 19-4 6-5 4-5 2-268 1-5 1-2 11-6 20-11 28-6 13-10 20-8 13-8 16 2 21-5 4-3 3v9l6 4-1 8-5 14-1 1h-11l-2 4-1 6 1 2v7l-14 10-8-1-5-1-3 6-12-3-21-7-2 6-11 10-13 10-10 7-18 11-20 11-16 8-6 2v8l11 30 7 21 6 23 5 21 5 30 2 25 1 11h-127l-7-34-9-38-6-23-7-24-5-16-8 1-24 1-7 1-7 24-8 31-6 21-12 43-4 13h-116v-34l3-30 2-12-1-2-175-1-8-5-6-7-2-11-1-58-2-61-1-67v-23h-80l-10-2-8-5-4-8-1-4-1-19-1-46v-28l4-8 6-5 7-2 25-1-3-10-3-15-4-26-3-36v-41l3-32 2-16 5-24 8-29 8-22 5-11 5-13 7-16 6-11 13-22 7-11 9-13 11-15 8-9 9-11 24-24 8-7 9-8 11-9 13-10 11-8 11-7 20-12 14-8 26-11 13-6 12-5h11l-1-5-8-16 2-4zm527 279 1 10 2 1 1-7-2-4z",
    fill: "#81DFF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(812,145)",
    d: "m0 0h1v8l-2 8 12-2 5-2 16-3h8l6 7 3 9 1 10 10 15 1 11-5 12-8 17-5 35 4 2v1h-5l2 12 8 17v12l-2 7v4h-2l-1 10-10 25-8 16-7 10-6 7-6 1-16 1 4 2 7 12 8 7 16 9 17 8 18 10 14 9 13 9 11 9 4 5 2 6 4 24 7 34v6h-1l-2-9-3-8-3-12-2-14-4-16v-3h-2l-2 5-12 21-11 15-4 5h-2l-3-11-1 15-2 15-2 26-2 15-3 1-1 7-4 4-7 12-4 20-11 63-3 21v9l4 7 7 9 1 6-5 7-3 1v8l15 25 2 6-7 12-2 3h-2l-2 5-1 2-1 12 5 2 8 6 2 2v14l4 5 14 28 12 29 8 23 7 22 5 19 5 21 5 30 2 25 1 11h-127l-7-34-9-38-6-23-7-24-5-16-8 1-24 1-7 1-7 24-8 31-6 21-12 43-4 13h-116v-34l3-30 2-12-1-2-175-1-8-5-6-7-2-11-1-58-2-61-1-67v-23h-80l-10-2-8-5-4-8-1-4-1-19-1-46v-28l4-8 6-5 7-2h125l1-10-12-23-12-22-13-25-2-4-12-3-9-6-5-6-5-17v-16l2-9 2 1 1 3 8-1 8 20v2l6 1h10l6-9 1-5-10-18v-2l6-2-2-7 10 5 12 11 7 10 3 7v11l-4 11-2 4 2 6 1 5v7l3 5 5 5 20 48 1 2 10 5 4 5 6 11 1 4v8l-4 10-7 6-2 1-1 13-2 62h177l1-6 8-10 9-9-2-10-7-30-6-35-3-24-2-33-2-5h-2l-5 12-11 22h-2l-3 9h-2l-2 7h-2l-1 5h-2v3h-2v3h-2v3h-2l-1 4h-2l-1 4-3 2-3 5-17 17-10 8-10 7-9 5-8-1-9-7-9-12-10-18-7-16-4-20-3-25-3-48-7-14 1-6 7-7h2l-6-17v-5l11-7 1-9-5-2-9-7-4-4-1-23-3-9-6-7-3-7v-6l10-8 1-8 9-7 5-2v-7l8-4 4-1h8l5 3 11 14 5 1-1-13-2-8v-14l2-6v-10l-1-6v-16l2-8h-30v-64l64-2h13l5 8-1 19-1 34-1 6h-19l-13-1 1 4v13l-1 19v12l1 13 7 17 11 19 1 3v7l-7 11-16 21-7 15 5 2 1 32 2 1 10-4h3l-1-10 5-4 8-4 8-27 4-10 6-5 36-14 36-15 33-15 9-5 12-14h6l10-30 3-14 1-13 3-6 5-9 3-8 1-4v-13l-4-12-2-3-1-17-6-22-2-7v-9l3-5 6-4 7-4 7-3 12-7 12-13 9-6 7-4 10-3 9-4z",
    fill: "#5A60B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(593,99)",
    d: "m0 0 3 1 12 25 3 1 2-4 7-3 22-5 33-4 4-1 26-1h29l17 1 4 1 25 2 23 4 28 7 16 5 29 11 20 9 25 13 15 9 16 11 12 8 16 13 10 8 12 12 7 6 7 8 14 14 9 11 13 17 10 14 11 18 8 13 4 8 1 7-32 1-106 1v2l-5 3h-2l-1 4-2 3v32l2 55 1 13 1 28 1 46 1 39-5-4v-2h-2l-6-12-4-24-5-24-4-22-4-6-12-10-12-8-19-12-21-11-17-8-13-9-6-7-4-7v-2l-4-1-2-2 18-1 7-2 8-10 7-12 10-24 4-10 2-10h2l-1-5h2v-18l-8-17-1-3v-9l4-1-4-2 5-35 8-17 5-12-1-11-4-5-6-10-2-14-4-8-3-3h-8l-20 4-1 1-12 1 1-15-10 6-12 5-8 3-13 7-9 9-5 6-15 9-7 3-10 6-2 4v9l6 21 2 8 1 17 4 8 2 7v13l-3 10-5 10-3 4-1 3-1 13-5 21-7 19-2 4-7 2-12 14-27 13-40 17-46 18-5 4-6 16-6 21-12 7-1 1v10l-14 5-2-2v-32l-5-2 3-9 6-10 14-18 6-10v-7l-7-14-7-12-5-13-1-13v-14l1-17v-17h13l19 1 1-40 1-19-4-7-48 1h-29v64h30l-1 8v16l1 6v10l-2 6v14l2 8v13h-5l-9-11-4-5-3-1h-8l-10 4h-2v7l-12 8-1 1-1 8-9 8h-2l2 9 6 9 3 3 2 8 1 23 9 8 8 5v9l-11 7 1 8 4 10v4l-8 7-1 6 7 14 3 48 3 25 4 20 7 16 10 18 10 13 7 5 8 1 12-7 9-7 11-9 15-15 3-5 2-1 1-3 2-1 1-3h2v-3h2v-3h2v-3h2l1-5h2l1-5 1-2h2l1-5 2-4h2l3-9 9-17 4-10 4 3 2 16 1 21 5 37 7 36 6 23-1 4-11 11-6 9-1 4h-177v-31l1-31 1-13 8-6 4-7 1-4v-8l-3-8-7-11-11-6-17-40-4-10v-2l-4-2-3-3-1-3v-10l-2-3-1-7 4-6 2-7v-11l-6-12-9-10-11-8-4-1 1 5-6 2 11 20-1 5-6 9-1 1h-10l-6-2-8-19v-3l-5 2-4-1-1-3-2 8v16l5 17 6 7 9 5 10 2 3 5 14 27 12 22 11 21-2 10h-100l-2-9-3-10-5-33-3-36v-41l3-32 2-16 5-24 8-29 8-22 5-11 5-13 7-16 6-11 13-22 7-11 9-13 11-15 8-9 9-11 24-24 8-7 9-8 11-9 13-10 11-8 11-7 20-12 14-8 26-11 13-6 12-5h11l-1-5-8-16 2-4z",
    fill: "#23ce6b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(812,145)",
    d: "m0 0h1v8l-2 8 12-2 5-2 16-3h8l6 7 3 9 1 10 10 15 1 11-5 12-8 17-5 35 4 2v1h-5l2 12 8 17v12l-2 7v4h-2l-1 10-10 25-8 16-7 10-6 7-6 1-16 1 4 2 7 12 8 7 16 9 17 8 18 10 14 9 13 9 11 9 4 5 2 6 4 24 7 34v6h-1l-2-9-3-8-3-12-2-14-4-16v-3h-2l-2 5-12 21-11 15-4 5h-2l-3-11-1 15-2 15-2 26-2 15-3 1-1 7-4 4-7 12-4 20-11 63-3 21v9l4 7 7 9 1 6-5 7-3 1v8l15 25 2 6-7 12-2 3h-2l-2 5-1 2-1 11h-1l-1-8-5 9-9 3-16 4-24 4-9 1h-47l-23-2-20-3v-9l12 1 20 2h53l24-3 24-4 10-2-30 2-21 1h-46l-30-2-16-2v-23l19 2h15l-2-4-9-6-21-10-1-1v-30l12 3 15 4 13 2h28l25-3 17-4 13-5 14-8 6-5-5 2-15 7-15 5-13 3-16 2h-13l-22-3-15-5-10-4-16-9-14-10-14-12-7-8-6-9-4-16-1-9v-30l3 3 10 14 10 11 6 7 8 7 13 10 14 9 15 8 21 8 15 3-18-8-17-9-14-10-11-9-10-9-9-11-8-11-10-19-6-18-1-8 2-3h2v-4h2l2-5 6-10 3-3-10-3-16-8-10-7-10-9-6-7-14-11-11-9v2l4 14-1 3-25-15-8-5v13l1 18 3 3 3 12 4 14 3 19 1 17 2 1 2 3 1 4h-2v3h-2v3h-2l-1 4h-2l-1 4-3 2-3 5-17 17-10 8-10 7-9 5-8-1-9-7-9-12-10-18-7-16-4-20-3-25-3-48-7-14 1-6 7-7h2l-6-17v-5l11-7 1-9-5-2-9-7-4-4-1-23-3-9-6-7-3-7v-6l10-8 1-8 9-7 5-2v-7l8-4 4-1h8l5 3 11 14 5 1-1-13-2-8v-14l2-6v-10l-1-6v-16l2-8h-30v-64l64-2h13l5 8-1 19-1 34-1 6h-19l-13-1 1 4v13l-1 19v12l1 13 7 17 11 19 1 3v7l-7 11-16 21-7 15 5 2 1 32 2 1 10-4h3l-1-10 5-4 8-4 8-27 4-10 6-5 36-14 36-15 33-15 9-5 12-14h6l10-30 3-14 1-13 3-6 5-9 3-8 1-4v-13l-4-12-2-3-1-17-6-22-2-7v-9l3-5 6-4 7-4 7-3 12-7 12-13 9-6 7-4 10-3 9-4z",
    fill: "#B099EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(943,568)",
    d: "m0 0h2l1 35 3 12 3 1v2l5 2 433 1v1l-268 1-5 1-2 11-6 20-11 28-6 13-10 20-8 13-8 16 2 21-5 4-3 3v9l6 4-1 8-5 14-1 1h-11l-2 4-1 6 1 2v7l-14 10-8-1-5-1-3 6-12-3-21-7-2 6-11 10-13 10-10 7-18 11-20 11-16 8-6 2-1 6-2-3-10-23-10-19v-2l-3-1-1-2v-14l-7-6-7-4v-12l4-7h2l2-5 6-10-4-10-8-13-5-8v-8l4-2 4-6-1-6-10-13-1-3v-9l4-27 12-69 3-10 9-14h3l3 14 3 7 1 8h2l2 10h2l1 7h2l3 10 2-2 2-8 2 3 4 1h7l4 1 3-15 3-8 5-15 10-21 10-17z",
    fill: "#23ce6b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(387,759)",
    d: "m0 0h16l17 2 3 2 6 1 20 1v4h2v2l2-2 1-3 6-2 1 4h2v2h8l9-1h17l1 1 50 1v1l-85 2-4-1h-8l3 2 131 1 1 1v5h3v2l11 1h13l6 1h9 2l2-1-1 4-5 9 1 6 5 4-1 7 2 2-1 7-2 7-8 7-3 4h-2v2l5 2-2 6-12 29-12 34-10 36-7 31-1 3h-178l-6-4-2-4-3-1-2-4-1-21-2-79-1-60v-48l2-4z",
    fill: "#4D83E0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1327,336)",
    d: "m0 0h69l8 4 6 8 1 3v25l-1 16-1 71-2 41h-1v-49l2-84h-265l-7-9-7-6-14-6h-16l-12 4-9 7-6 7-2 4h-131l2 30 1 46 1 27 1 13 2 54v24l12-4h6l6 3v2h8l8-11 3-6h2l1-4 5-5 8 1 2 1v2l9 3 4 1 4-2 2-4 4-2v-2l6 1 2-3 1-5-4-2-5-6-3-7-2-13-1-6 6-5 7-8 5-10v-20l-3-11-4-6-3-2v-3l-4-2-8-5-9-3h-16l-10 3-9 6-4 4h-2l-2 5-3 7-2 6h-1v-63l9-1h94l3 15 5 9 2 4 4 2 11 7 6 3 10 2v13l5 1 5 5 1 5 10 8 4 6-2 5-7 10 4 1 2-4 8-9 3-1 5 5 1 7-14 23-11 14-14 15-12 10-8 5h-13l-2 5-3 6h-2l-1 4-4 5v21l-6 7-12 9v11h348l8-5 3-6 1-26 1-46 1-24 1-7h1v24l-1 62-2 19-4 6-5 4-2 1h-436l-5-3-4-5-2-4-1-6v-35h-2l-1 4-12 21-9 19-6 19-3 10-1 7-2 1-3-1h-8l-4-2-2 7h-3l-3-8v-2h-2l-1-7h-2l-2-10h-2l-4-14-2-4-2-11 1-7 2-1 3-25 2-27 1-4 1-17 2 2 2 7v4l5-5 11-15 15-26h2l3 9 2 10 2 14 4 16 3 8 3 10 4 7v2h2l4 5-1-38-1-46-1-28-1-13-2-55v-32l4-7 5-3h2v-2l3-1 222-2z",
    fill: "#6CBAEC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(812,145)",
    d: "m0 0h1v8l-2 8 12-2 5-2 16-3h8l6 7 3 9 1 10 10 15 1 11-5 12-8 17-5 35 4 2v1h-5l2 12 8 17v12l-2 7v4h-2l-1 10-10 25-8 16-7 10-6 7-6 1-16 1 4 2 4 7v10l-4 19-5 13-8 15-35 1-21 1-26-9-33-12-1 1 3 9-1 3-3-1-3-3v3h-2l-1 4-4-11v-10l-10-3-39-14-1-3 29-12 33-15 9-5 12-14h6l10-30 3-14 1-13 3-6 5-9 3-8 1-4v-13l-4-12-2-3-1-17-6-22-2-7v-9l3-5 6-4 7-4 7-3 12-7 12-13 9-6 7-4 10-3 9-4z",
    fill: "#8A6FD3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(844,829)",
    d: "m0 0 6 1 9 7 2 2v14l4 5 14 28 12 29 8 23 7 22 5 19 5 21 5 30 2 25 1 11h-127l-7-34-9-38-6-23-7-24-5-16-8 1-24 1-7 1-7 24-8 31-6 21-3 10-3 3v-4l-3-1-3-4h-2l-1 5-4 2-2 2-1-4-2 5-3-4v-2h-5l-2-5v-7l6-23 6-5 2-6h3l1-33v-17l2-45 6 2h1l-7-4v-26l1-3 20 2h58l16-2 25-4 21-6z",
    fill: "#5C3FA7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(553,243)",
    d: "m0 0h13l5 8-1 19-1 34-1 6h-19l-13-1 1 4v13l-1 19v12l1 13 7 17 11 19 1 3v7l-7 11-16 21-7 15 5 2 1 32 2 1 10-4h3l-1-10 5-4 8-4 8-27 4-10 3-2 1 21 4 20 5 17 4 11 4 8 7 9 3 11 2 10-11-6-15-9-8-5v13l1 18 3 3 3 12 4 14 3 19 1 17 2 1 2 3 1 4h-2v3h-2v3h-2l-1 4h-2l-1 4-3 2-3 5-17 17-10 8-10 7-9 5-8-1-9-7-9-12-10-18-7-16-4-20-3-25-3-48-7-14 1-6 7-7h2l-6-17v-5l11-7 1-9-5-2-9-7-4-4-1-23-3-9-6-7-3-7v-6l10-8 1-8 9-7 5-2v-7l8-4 4-1h8l5 3 11 14 5 1-1-13-2-8v-14l2-6v-10l-1-6v-16l2-8h-30v-64z",
    fill: "#B099EB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1143,772)",
    d: "m0 0h165l11 3 8 7 4 7 1 4v27l-3 90-4 9-6 7-9 4h-176l-8-4-5-4-5-9-2-33-1-42-1-14v-31l4-9 5-6 8-4zm65 45v5l2 2-1 4-2 9v13l2 4 5-1 13-8 10-7 5-3v-4l-28-14z",
    fill: "#E559EA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(971,390)",
    d: "m0 0h94l3 15 5 9 2 4 4 2 11 7 6 3 10 2v13l5 1 5 5 1 5 10 8 4 6-2 5-7 10 4 1 2-4 8-9 3-1 5 5 1 7-14 23-11 14-14 15-12 10-8 5h-13l-2 5-3 6h-2l-1 4-4 5v21l-6 7-12 9v12h-84l-6-4-4-5-2-5-1-16v-24l12-4h6l6 3v2h8l8-11 3-6h2l1-4 5-5 8 1 2 1v2l9 3 4 1 4-2 2-4 4-2v-2l6 1 2-3 1-5-4-2-5-6-3-7-2-13-1-6 6-5 7-8 5-10v-20l-3-11-4-6-3-2v-3l-4-2-8-5-9-3h-16l-10 3-9 6-4 4h-2l-2 5-3 7-2 6h-1v-63z",
    fill: "#81B9D3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(291,630)",
    d: "m0 0h143l9 4 5 6 1 4v25l-2 63-2 2 1 2-2 5h-3l-1-1-1 4-2 1h-7l-8-2-10-1h-15l-5 1-3-2-1-3-4 5-4 10h-86l-8-4-5-6-2-7-1-20-2-69 3-8 5-6z",
    fill: "#F586F7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(387,759)",
    d: "m0 0h16l17 2 3 2 6 1 20 1v4h2v2l2-2 1-3 6-2 1 4h2v2h8l9-1h17l1 1 50 1v1l-85 2-4-1h-8l3 2 131 1 1 1v5h3v2l11 1h13l6 1h9 2l2-1-1 4-5 9 1 6 5 4-1 7 2 2-1 7-2 7-8 7-3 4h-2v2l5 2-2 6-5 12h-6l-4 2-4-1-1-1h-18l-12-4h-3v5l-2-4-68-1v7h66l2 2-15 1h-25l-4 1-2 3v-2h-20v-1h13v-2h-20l2-2 1-7h-34v-1l26-1-26-1 1-2 82-1v-6h-94l-2-6h-22v2l-15 1-14-1-6-3-4 2-1 3-2-1-1-33v-48l2-4z",
    fill: "#546BC7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(763,193)",
    d: "m0 0h17l54 4 6 4 7 8 4-1 5 8 2 5v5l-4 2-2 5h-2v3h-2l-1 5-2 5 4-3h8l2-1-2 12-2 16 4 2v1h-5l2 12 8 17v12l-2 7v4h-2l-1 10-2 6h-1l-3-12-1-1 1 2v9l-1 7-5 10h-2l-2 4-5-1-4-7-3-10h-11l1 1h7l1 5h-4v-3l-4 3-1 1 1 2h-2l1 3-8 3-2 3-1 2 8 1v-3h2v-2l9-1 4 2 2 3v3h-2v3h4v-2h2l-2 4-2 3h-2v-3h-23l-7 1-13-1h-8l-2-4 13-1-13-1-5-3 2-1v-4l-3-1 4-1-4-4 2-1-3-2-1-9 1-6v-3h-3l-1-1-1-7-1-2 1-3-9-7-3-4v-2l-3-1v-3h-2l-7-14-2-10v-17l4-13 7-14 4-5-1-5-3-5v-13l3-5 5-4z",
    fill: "#FBAEA3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(640,770)",
    d: "m0 0 13 5h7l4 2h15l5 3v2h2l1 4 2 2v43l-1 20v25l-2 84-1 12h-2l-1 6-7 6-2 1h-95l2-13 10-40 11-35 12-31 8-18v-2l-4-2v-2l5-5 8-7 2-9-1-5-1-4 1-4-5-4-1-6 7-12 6-12z",
    fill: "#3953BF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1106,369)",
    d: "m0 0 10 2 7 6 4 7v12l-3 6-8 7-5 2h-9l-8-3-6-7-3-6v-5h-17l4 17 6 9-1 3-5-5-5-9-2-11v-4l-103 1 1 60 3-9 4-6 11-9 10-4 4-1h16l13 5 8 6 1 3 5 5 3 5 2 9v20l-5 10-5 6h-2l-1 3-5 5 2 8 1 10 5 10 6 5v5l-3 4-6-2v2l-5 4-5 5-9-3-4-2v-2l-10-1-5 5-1 3h-2l-2 6-8 11-5 1-4-1v-2l-4-1-2-1-10 1-8 2-2-45-1-33-1-13-1-27-1-46-1-18v-12l134-1h24zm14 9 1 10 2 1 1-7-2-4z",
    fill: "#81DFF8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(553,243)",
    d: "m0 0h13l5 8-1 19-1 34-1 6h-19l-13-1 1 4v13l-1 19v12l1 13 7 17 11 19 1 3v7l-7 11-16 21-7 15-1 7h-2l-1 5-4 5h-3v3l-3 3-11 6-11 4h-5l-1-22-5-2-9-7-4-4-1-23-3-9-6-7-3-7v-6l10-8 1-8 9-7 5-2v-7l8-4 4-1h8l5 3 11 14 5 1-1-13-2-8v-14l2-6v-10l-1-6v-16l2-8h-30v-64z",
    fill: "#E67CA1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(852,634)",
    d: "m0 0h1l-1 10-11 64-1 9v9l4 7 7 9 1 6-5 7-3 1v8l15 25 2 6-7 12-2 3h-2l-2 5-1 2-1 11h-1l-1-8-5 9-9 3-16 4-24 4-9 1h-47l-23-2-20-3v-9l12 1 20 2h53l24-3 24-4 10-2-30 2-21 1h-46l-30-2-16-2v-23l19 2h15l-2-4-9-6-21-10-1-1v-30l12 3 15 4 13 2h28l25-3 17-4 13-5 14-8 6-5-2-6v-11l2-12 2-5 6-30 4-15 4-18z",
    fill: "#B099EB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1152,791)",
    d: "m0 0h138l4 1 1 48v36l-2 4h-145l-2-1-1-16 1-71zm56 26v5l2 2-1 4-2 9v13l2 4 5-1 13-8 10-7 5-3v-4l-28-14z",
    fill: "#C969E7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(391,903)",
    d: "m0 0 5 1 4 4 10 1 4 2 17 1 16 4 2 4-1 6 3 1v2l10-1h10v-2l4-1 2 1v2h67l5 1 1-3 1 2h15l8 3h15l1-3 1 4-10 40-3 13h-178l-6-4-2-4-3-1-2-4-1-21v-30l1-13 3-1z",
    fill: "#3F8BEE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(844,829)",
    d: "m0 0 6 1 9 7 2 2v7l-2 4-18 6-16 8-12 8-14 11-8 7-7 8-2 4 10 22 5 12-1 4-12 1-3-1 2 7-3-3-7-17-8-16-4-6-8-7h-14l-6 2-7 24-5 21-7 25-9 32-5 18-3 3v-4l-3-1-3-4h-2l-1 5-4 2-2 2-1-4-2 5-3-4v-2h-5l-2-5v-7l6-23 6-5 2-6h3l1-33v-17l2-45 6 2h1l-7-4v-26l1-3 20 2h58l16-2 25-4 21-6z",
    fill: "#412288"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(812,145)",
    d: "m0 0h1v8l-2 8 12-2 5-2 16-3h8l6 7 3 9 1 10 10 15 1 11-5 12-8 17-2 9h-9l-3 3-2-1 4-10h2v-3h2l2-5 3-2-1-7-5-10-4 1-9-10-4-2-54-4h-17l-6 3-3 3-1 3v13l4 7-1 4-7 11-6 15-1 5v17l2 10 6 12v2h2l1 3 5 5v2l4 2 5 4 6 1v1h-6l2 11 2 1 2-2v9l-1 5 1 6 3 3v2l4 2-4 2-1 5 4 2 14 1-1 2-12 1 1 2h10l13 1 5-1 23 1v3h2l2-4 2-3h-2v2h-4v-3h2l-4-7h-11v2h-2v3h-8l-1-2 4-5 7-3 1-3-2-2 4-1-2-2h5v3h4l-1-4h-10l2-3h11l3 7 3 8 2 3 5-1 4-5 3-7 1-7v-9l-2-6 3 2 3 10-1 9-8 19-6 12-7 10-6 7-26 1-23-5-10-4-11-8-12-11-8-9v-2h-2l-9-16-4-9v-16l3-6 5-9 3-8 1-4v-13l-4-12-2-3-1-17-6-22-2-7v-9l3-5 6-4 7-4 7-3 12-7 12-13 9-6 7-4 10-3 9-4z",
    fill: "#2B328F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(569,523)",
    d: "m0 0 9 5 25 15-4-16-1-3 4 2 14 11 10 8 7 8 10 9 17 10 17 7-1 3h-2l-2 6-6 9h-2v4h-2l-1 7 5 17 10 21 9 13 9 10 6 7 11 9 15 11 16 9 17 8 8 3v1l-10-1-16-5-17-7-18-10-19-14-7-7-8-7-9-11-8-10-5-8v29l3 19 4 9 6 8 7 8 11 9 11 8 15 9 16 7 13 4 22 3h13l22-3 17-5 12-5 11-6 3 1-8 7-17 9-21 6-19 3-11 1h-28l-18-3-20-6h-3l-3-8-6-5-7-3-49-1 1-6 8-10 9-9-2-10-7-30-6-35-3-24-2-33-2-5h-2l-5 12-11 22h-2l-3 9h-2l-2 7h-2l-1 5-5-1-2-3h-1l-2-27-5-22-3-8-2-7-2-2-1-18z",
    fill: "#8979E1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(863,856)",
    d: "m0 0 4 5 11 23 10 24 9 24 8 24 6 23 5 21 5 30 2 25 1 11h-79l-5-15-3-8-8-22-4-12-3-8-5-14 2-7-2-1 6-19h2l1-5 4-6 13-7 8 1 3 1 10 10 5 4 3 2 2 6h2v2h4l6 9 5 10 5 9 2-2 2-4h-2v-5h2l-2-9h3l1-4h-3l-1-6v-9l-3-8-8-24-3-11-3-7-4-12-11-28-3-8z",
    fill: "#6F58BA"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1059,134)",
    d: "m0 0h116l1 1v15l-2 37-3 37-2 1h-110l-2-4-3-65v-17zm21 17-1 1v16l2 43 6 1 8-1 2-2v-3l-8-2-1-2-1-27v-16l1-1 9-2-1-3-11-2zm63 1-7 1-1 4 9 1 1 1v26l-1 18-9 3 1 5 13 1 2-2 1-29v-29z",
    fill: "#13A0D0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(418,797)",
    d: "m0 0 8 1 10 1 11 2 2 2v7l1 3h110l-1 2-108-1v5h109 2l4-2 1-1h11l11 1v2h14l1 1 9 1 2 1 9 1 6 2 1 5-9 8-3 4h-2v2l5 2-2 6-5 12h-6l-4 2-4-1-1-1h-18l-12-4h-3v5l-2-4-68-1v7h66l2 2-15 1h-25l-4 1-2 3v-2h-20v-1h13v-2h-20l2-2 1-7h-34v-1l26-1-26-1 1-2 82-1v-6h-94l-2-6h-22v2l-15 1-14-1-6-3-4 2-1 3-2-1v-45l3-2h9l6 4h9l2-3h5z",
    fill: "#5376CE"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1327,336)",
    d: "m0 0h69l8 4 6 8 1 3v25l-1 16-1 71-2 41h-1v-49l2-72v-33l-4-7-8-4h-73l-293 2-78 1-8 4-4 7v31l1 18 1 46 1 27 1 13 2 54 1 51 1 13 4 8 5 4 2 1h432l8-5 3-6 1-26 1-46 1-24 1-7h1v24l-1 62-2 19-4 6-5 4-2 1h-436l-5-3-4-5-2-4-1-6v-35h-2l-1 4-12 21-9 19-6 19-3 10-1 7-2 1-3-1h-8l-4-2-2 7h-3l-3-8v-2h-2l-1-7h-2l-2-10h-2l-4-14-2-4-2-11 1-7 2-1 3-25 2-27 1-4 1-17 2 2 2 7v4l5-5 11-15 15-26h2l3 9 2 10 2 14 4 16 3 8 3 10 4 7v2h2l4 5-1-38-1-46-1-28-1-13-2-55v-32l4-7 5-3h2v-2l3-1 222-2z",
    fill: "#6F59BB"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(673,984)",
    d: "m0 0h2l-2 10-3 12v8l1 4h5l3 5 2-6 2 4 5-3 1-4 3-1 2 5 4 1 1 6-9 31-3 10h-116v-34l3-30 2-12-1-2-171-1v-1l265-1z",
    fill: "#6F58BA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(385,678)",
    d: "m0 0 5 1v2l6 2 11 12-1 3-5 4h-2v2l-9 7v13l11-9 14-12 5-5-10-11-3-6 1-2h10l7 1h21l2 3v24l-1 25-2 2 1 2-2 5h-3l-1-1-1 4-2 1h-7l-8-2-10-1h-15l-5 1-3-2-1-3-4 5-4 10h-86l-8-4-5-6-2-7-1-20v-17h1l1 11 4-2h18l8 1 2 5 4-1 7 4v2l6 2 3 2v-13l-10-9-7-6 2-5 6-3v2l13-1 1-7 13-2 5 1 2-1 1 3-4 9-1 5-12 27v1l8 1 2-5 8-15 12-24 5-2v2h2l1-2z",
    fill: "#E559EA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(943,568)",
    d: "m0 0h2l1 35 3 12 3 1v2l5 2 433 1v1l-348 1-14 14-8 7-12 11-14 11-16 12-17 11-15 9-9 5-8-1-9-6-10-9-9-12-8-14-3-6 3-12 2 3 4 1h7l4 1 3-15 3-8 5-15 10-21 10-17z",
    fill: "#B099EB"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1020,723)",
    d: "m0 0 9 1 10 5 13 4 2 1-2 9 12 3v3h2l2 17-5 4-3 3v9l6 4-1 8-5 14-1 1h-11l-2 4-1 6 1 2v7l-14 10-8-1-5-1-3 6-12-3-21-7-1-5 3-7-10-1-3-1-2-7-1-14 4-1v-2l3-2 1-10h2l-1-3-7-1v-7l5-11 2-4 5 1 1 3 3-3 4-6-1-14h2l1-3 6-3 4-4 5-1 6 4h3l1-3h2z",
    fill: "#17A0D1"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(674,514)",
    d: "m0 0h63l60 3 50 4 17 2-1 25-1 10h-12l-62-3-13-1-83-1-18-1z",
    fill: "#765EBF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1314,774)",
    d: "m0 0 5 1-3 1zm-182 1h180l7 3 7 6 4 9v26l-1 20-2 5-4 2-17 1-2-1-8 2v5h-1l-1-13v-48l-149-1v58l-2-3-4 1h-18l-2-1-1 3h-2l-1-6-1-19v-32l4-8 7-6z",
    fill: "#F98FF7"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(597,911)",
    d: "m0 0 4 1v2h10l17 2h10v2l5-1 12 2h15l4 4 6-2h4l1 4v31l-1 16-3 7-8 6h-95l2-13 10-40 6-20z",
    fill: "#1F6AD7"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1030,539)",
    d: "m0 0 5 2-1 8 3 11v7l3 1 4 10 1 3h2l3 3 5-5 4-6h1l1 5v14l-6 7-12 9v12h-84l-6-4-4-5-2-5-1-16v-24l12-4h6l6 3v2h8l8-11 3-6h2l1-4 5-5 8 1 2 1v2l9 3 4 1 4-2 2-4 4-2z",
    fill: "#6BB9EC"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(386,470)",
    d: "m0 0 10 5 12 11 7 10 3 7v11l-4 11-2 4 2 6 1 5v7l3 5 5 5 20 48 1 2 10 5 4 5 6 11 1 4v8l-4 10-7 6-3 1-1-14-3-6-7-6-7-2-16-1 1-10-12-23-12-22-13-25-2-4-12-3-9-6-5-6-5-17v-16l2-9 2 1 1 3 8-1 8 20v2l6 1h10l6-9 1-5-10-18v-2l6-2z",
    fill: "#8979E0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(763,193)",
    d: "m0 0h17l54 4 6 4 7 8 4-1 5 8 2 5v5l-1-4h-2l-5-6-7-4-8-3-6-1h-14l-15 4-11 7h-2v2l-6 5 16-3 9-3 14-3h3v13l-3 20-6 23-2 6-6 1h-10l-18-5-6-3h-5l-10 7-3 1v-2l-5-1-2 1v9l4 9-2 1-6-12-2-10v-17l4-13 7-14 4-5-1-5-3-5v-13l3-5 5-4z",
    fill: "#E279A1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(451,745)",
    d: "m0 0h10l6 1 32 1 13 3 3 2h6v1h30l4 4 9 1 6 1 17 1 9 1 22 1 5 3 8-1 4 4 4 2-1 6-5 10-5 2v-2l-10 1-5-1h-19l-5-2v-2h-3l-1-5-131-1-4-2 1-2h10l5 1 45-1-13-1-1-1h-22l-4 1h-9l1-3h-2l-1-3-6 1v5h-3v-2h-2v-4h-20l-7-2-9-2-10-1h-16l-2 1-1 3v48l1 60 2 79 1 21 2 4 5 5 5 3 269 1v1l-269 1-8-5-6-7-2-11-1-58-2-61v-90l51-1 8-3 8-5z",
    fill: "#5767BA"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(626,732)",
    d: "m0 0h49l10 5 5 6 2 6 1 29 23 11 9 7v4h-15l-17-2-2-1v23l16 1 30 2h46l40-2 12-1-1 2-20 4-28 4-10 1h-53l-26-3-6-1v9l15 1 15 2 13 1h47l22-3 19-4 14-4h3l2-5 3-6h1l1 11-16 8-21 6-30 5-11 1h-58l-20-3-1 29 6 2 4 4-6-2-4-2v18l-1 27v21l-1 23-1 6h-1l2-102v-23l1-16v-43l-2-2v-4h-2v-2l-4-1-1-1h-15l-4-2h-7l-13-5-1-3-1-9-4-9-8-15-178-1v-1z",
    fill: "#5746B5"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(424,636)",
    d: "m0 0h6l2 6 8 6 8-2 1-2v25l-1 14-2-2h-25l-7-1h-6l3 7 10 11-5 5-12 11-10 8-5 3v-14l8-7h2v-2l7-5-2-4-9-10-5-2-2-2-9 1-3 1v-2l-5 2-2 6-8 15-8 16-4 7h-8l-1-2 13-29 1-6 3-7-8-1-9 1h-3l1 5-2 3h-13-2l-4 1-1 5 13 12 4 3v14l-6-4-15-13-11-9 2-4 2-3h2l1-4 5-5 9-10 4-6-1-3 2-9 7-1 11-1h12l3 1h16l6 2 6-2 4 2v-2l4 1 2-2h21l3-1 2 1-4-9v-6z",
    fill: "#ED7BF3"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(971,390)",
    d: "m0 0h94l3 15 5 9 2 4 2 1-8 20-10 23-8 15-9 8-3 1-1-3 4-8v-20l-3-11-4-6-3-2v-3l-4-2-8-5-9-3h-16l-10 3-9 6-4 4h-2l-2 5-3 7-2 6h-1v-63z",
    fill: "#6CBAED"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(553,243)",
    d: "m0 0h13l5 8-1 19-1 34-1 6h-19l-17-1h-43v-64z",
    fill: "#E45AE9"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1030,340)",
    d: "m0 0h118v1l-22 1h10 3 6l-1 2h-5v5l4-1 2 4-2 13-1 2h2v3l2 1-4-1-6-8-7-6-14-6h-16l-12 4-9 7-6 7-2 4h-131v-19l5-8 8-4z",
    fill: "#5C9BDE"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(812,145)",
    d: "m0 0h1v8l-2 8 12-2 5-2 16-3h8l6 7 3 9 1 10 10 15 1 11-5 12-8 17-2 9h-9l-3 3-2-1 4-10h2v-3h2l2-5 3-2-1-7-5-10-4 1-9-10-4-2-29-2-5-1-1-2-12-1h-24l-9 2-6 3-7 4-10 3h-8l-2-1 2-4 6-4 7-4 7-3 12-7 12-13 9-6 7-4 10-3 9-4z",
    fill: "#163F92"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(571,556)",
    d: "m0 0 3 2 3 12 4 14 3 19 1 17 2 1 2 3 1 4h-2v3h-2v3h-2l-1 4h-2l-1 4-3 2-3 5-17 17-10 8-10 7-9 5-8-1-9-7-9-12-10-18v-5l-2-3-2-10 3-3h6l2 1v2l8-3 5-2 6-2 3-3 6-2 1-6 8-4h7l-1 2 6-2v2l3 1-1 4h2l-1 18 6-10 5-10 8-7v-3l4-1-2 5 5-1v-2h2v-2l-4-1 3-1-1-13-6-28z",
    fill: "#9483E8"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(569,523)",
    d: "m0 0 9 5 25 15-4-16-1-3 4 2 14 11 10 8 7 8 10 9 17 10 17 7-1 3h-2l-2 6-6 9h-2v4l-4 1-15-8v-2l-6-2-2-2-8 3-1 5v8h-1l-2-17-2-16-2-2-3 5-3 8-11 22h-2l-3 9h-2l-2 7h-2l-1 5-5-1-2-3h-1l-2-27-5-22-3-8-2-7-2-2-1-18z",
    fill: "#6252BB"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1205,828)",
    d: "m0 0h1v29l16-10 7 1 63 1 2-2v32l-1 1h-145l-2-1-1-16 1-15 6 3v-2h46l6-2z",
    fill: "#C157E2"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(998,425)",
    d: "m0 0h9l13 4 9 6 4 5 7 13v19l-5 13-9 10-15 6h-16l-11-4-8-6-4-4-6-12-2-10v-8l3-8 5-9 5-6h2l1-3 13-5z",
    fill: "#7BCFF2"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(537,373)",
    d: "m0 0 2 3 8 16 8 14 1 3v7l-7 11-16 21-7 15-1 7h-2l-1 5-4 5h-3v3l-3 3-11 6-11 4h-5l-1-22-5-2-9-7-4-4v-22l10-3 16-7 11-11 4-1 7-2 21-2h3l2 1v-8l-4-6-1-4v-16z",
    fill: "#FBAEA2"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(791,309)",
    d: "m0 0h28l9 2 16 2 7 3 3 4v2h2v2l5-1-3 15-2 3-3-12-1-1 1 2v9l-1 7-5 10h-2l-2 4-5-1-4-7-3-10h-11l1 1h7l1 5h-4v-3l-4 3-1 1 1 2h-2l1 3-8 3-2 3-1 2 8 1v-3h2v-2l9-1 4 2 2 3v3h-2v3h4v-2h2l-2 4-2 3h-2v-3h-23l-7 1-13-1h-8l-2-4 13-1-13-1-5-3 2-1v-4l-3-1 4-1-4-4 2-1-3-2-1-9 1-6v-3h-3l-1-1-1-7-1-2 1-2 7-2 5-1v-2z",
    fill: "#183E92"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(832,900)",
    d: "m0 0 13 2 6 4 3 4v2l8 4 14 18 3 8 5 5 3 4 1 5 3 1 6 15 1 1 1 2v7l2 1-1 2h-2v5h2l-1 5-3 3-14-26-4-3-2-1v-2h-2l-3-6-6-4-5-5-9-7-8-1-13 7-5 10h-2l-2 9-3 10 1 4-1 2h-2l-10-27-1-6 3-6v-16l1-7 3-3 4-10 3-2 2 1 2-5 5-3z",
    fill: "#6E4EAF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(739,897)",
    d: "m0 0h14l11 10 9 19 6 13 10 25 11 33 5 16 8 32 3 16v5h-19l-7-34-9-38-6-23-7-24-5-16-8 1-24 1-8 1 4-17 5-17 2-2z",
    fill: "#614FBB"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(674,514)",
    d: "m0 0h63l1 2-3 1 5 1 1 2 9 3 2 4 1 7 1 1 18 3v4h-20v5l25-1 3-1-1-8-14-4-6-1 1-4 14 1 1 2 3-1 1-3h2l1 2v20h8v-21l2 3v13h2v3l8 2 19 1v1h-24l-1 1h7l3 2h-31l-83-1-18-1z",
    fill: "#7A49A5"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(886,561)",
    d: "m0 0 3 2 3 6 7-3h22l10 1 5 5v2h2v-2h2v-2l3-1-2 4-14 26-7 16-5 16-3 10-1 7-2 1-3-1h-8l-4-2-2 7h-3l-3-8v-2h-2l-1-7h-2l-2-10h-2l-4-14-2-4 1-5h2l-1-4 1-2 8 1 3 1z",
    fill: "#7966D1"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1245,401)",
    d: "m0 0h64v44l-1 12h-4l-48-1-9-2-1-1-1-34z",
    fill: "#7CD1F4"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(844,829)",
    d: "m0 0 6 1 9 7 2 2v7l-2 4-18 6-12 6h-8l-9 3-6 3h-106l-10 2v-24l20 2h58l16-2 25-4 21-6z",
    fill: "#371B7E"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1170,401)",
    d: "m0 0h63v53l-2 2-57 1-3-4-1-3z",
    fill: "#7CD1F4"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1319,401)",
    d: "m0 0h63v51 3l-3 1h-59l-1-19z",
    fill: "#7CD1F4"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1059,134)",
    d: "m0 0h116l1 1v15l-2 37-1 11h-1v-24l-2 1-2-1v2l-8 1-2-2-1-3-2-1-1-11-2 53-4-1 2-2 2-58-16 2-1 3h9l2 2v26l-1 18h-1l-1-37-3 1v2l-6 1-6-3-3-4-15-1-9-1-2-1v-6l-1-1-1 5h-9v-1l9-1-1-2-14-3v-2l-7 1-1 2-6-1-6 2-2-1-1-3-1-12-3 2 2-4z",
    fill: "#20B4E1"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(731,899)",
    d: "m0 0 2 1-7 24-5 21-7 25-9 32-5 18-3 3v-4l-3-1-3-4h-2l-1 5-4 2-2 2-1-4-2 5-3-4v-2h-5l-2-5v-7l6-23 6-5 2-6h3l1-33v-17l1-22 7 6 4 4-1 5-6 18-1 6h3l1-2 12 6 1-7 5-10 9-19z",
    fill: "#5235A3"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(722,327)",
    d: "m0 0 3 4 4 10 7 12v2h2l6 8 10 10 12 9 10 5 15 4 12 2h19v1l-16 1 4 2 4 7v10l-4 19-5 13-8 15h-22l-1-2h2v-2l7-6 1-2h2l2-5 3-5 4-8h2l2-11 2-12-7 8-9 4h-12l-6-3-9-9-10-14-12-21-11-20-5-9v-8z",
    fill: "#7644A0"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(609,876)",
    d: "m0 0 4 3 3 1h7l4-1 3 2 23-1 4 2 12 2 6 3 10 8 1 2v63l-1 12h-1v-47l-1-3-5 1-4 1-4-4h-18l-12-2h-2v-2l-3 1-16-1-20-2-2-5 11-31z",
    fill: "#3760CB"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(815,207)",
    d: "m0 0h14l12 3 6 3 8 7v2h2v5l-3 1-2 5h-2v3h-2l-1 5-2 5 4-3h8l2-1-2 12-2 16 2 2h-4v11l-2 3h-5l-1 4 4 8-1 7-7 4-9 1-16-4-4-4h11l9 1h15l-5-14-4-8-2-3 4 2 3 1 1-7-8 1-4-1v2h-10l-1 5-5 4h-6l-2-4h-9v-1l13-1 2-9 5-20 3-20 1-13-25 6-1 1-11 2-6 1 5-6h2v-2l13-8z",
    fill: "#FBA19A"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(943,568)",
    d: "m0 0h2l1 35 3 12 3 1-1 2h-2l1 4-3 6v7l-2 6-4 3-6 11-6 9-4 4h-2l1 7-3 6 1 7 1 5-3 1v-2h-5l-10-11-10-16-5-10 3-12 2 3 4 1h7l4 1 3-15 3-8 5-15 10-21 10-17z",
    fill: "#9483E8"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(797,937)",
    d: "m0 0 2 2 7 18 4 9 14 38 7 20 8 21 4 13 2 8h-29l-7-34-9-33-10-29-8-21-1-9 15-1z",
    fill: "#5032A2"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(719,341)",
    d: "m0 0 3 4 6 12 13 23 10 17 10 13 7 7 5 2h12l10-5 6-8h1l-1 7-4 10-7 7-9 5-8 3-8-1-15-5-11-7-6-7v-2h-2v-2l-4-2-2-6h-2l-3-5-8-13-3-6v-3h-2v-6l7-16z",
    fill: "#B164AC"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(637,587)",
    d: "m0 0 4 3 4 2v2l5 2 11 5v3l1 8 6 18 11 21 11 14 10 11 11 9 15 11 16 9 17 8 8 3v1l-10-1-16-5-17-7-18-10-19-14-7-7-8-7-9-11-8-10-5-8v-2l-4-2-4-3v-2l-4-2-8-10-4-8v-9l1-3 1-5z",
    fill: "#7966D1"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(763,191)",
    d: "m0 0h24l12 1 1 3h-9l-11-1h-17l-6 3-3 3-1 3v13l4 7-1 4-7 11-6 15-1 5v17l2 10 6 12v2h2v8h3v3l5 2 4 4 1 4h-4l-1 2-4-2-1-4h-11l-2 3 2 1-11 1-5 4-3-3v-5l-1-2h3v-6h3l1-3v2l5-1-3-3v-6l2-4v-20l-4-12-2-3-1-17-6-22-2-7v-9l3-2v2l16-3 8-4 5-3 5-2z",
    fill: "#173D90"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1222,500)",
    d: "m0 0h160v15h-160z",
    fill: "#6CBAED"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(962,473)",
    d: "m0 0 2 3 6 12 7 7 10 6 8 2h15l10-3 4-2 3 9 1 10 5 10 4 5h-75l-1-57z",
    fill: "#7BD0F3"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(863,856)",
    d: "m0 0 4 5 11 23 10 24 9 24 8 24 6 23 5 21 5 30 2 25 1 11h-20l-1-3 4-2-1-7-3-3-1-3v-9l-2-1 1-4-1-8-3-7v-7l2-2 1-5-3-5v-6h2l1-4h-2v-5h2l-2-9h3l1-4h-3l-1-6v-9l-3-8-8-24-3-11-3-7-4-12-11-28-3-8z",
    fill: "#6052BB"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(598,524)",
    d: "m0 0 4 2 14 11 10 8 7 8 10 9 17 10 17 7-1 3h-2l-2 6-6 9h-2v4l-4 1-15-8v-2l-6-2-2-2-8 3-1 5v8h-1l-2-17-2-16-2-2-4 7-2-8-3-5-3-3v-2h-2v-3h-2l-3-11-5-1v-2l4 1 2 1-4-16z",
    fill: "#5747B5"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(844,818)",
    d: "m0 0h1l1 11-16 8-21 6-30 5-11 1h-58l-16-2-4-2v-19l1-6 16 1 30 2h46l40-2 12-1-1 2-20 4-28 4-10 1h-53l-26-3-6-1v9l15 1 15 2 13 1h47l22-3 19-4 14-4h3l2-5z",
    fill: "#826DD7"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(553,243)",
    d: "m0 0h13l5 8-1 19-1 34-2 5-2-1 1-1v-11l-1-1-1-25-1-1-11 1-2-2-6 5-3 2h-3v3l4 3v2l4 2v3l-3-2v-2l-4-2-5-5 3-1v-2l9-7-2-5-4-4-10 9-4 3h-2v-2l-4-2-9-7v-2h-3l-1 4-4 6 13 9-2 4-2 1-1-5-10-5h-2v-2h-5l-2 5-1 1-1 32 2 1h-3v-63z",
    fill: "#E07BA4"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(413,535)",
    d: "m0 0 2 2v10l3 5 5 5 20 48 1 2 10 5 4 5 6 11 1 4v8l-4 10-7 6-3 1-1-14-3-6-7-6-7-2-16-1 1-10-8-15v-2l3-1v-7h2l4 4 3-3 1-3 2-1 1-6-6-16-12-30v-1h5z",
    fill: "#B19AEC"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(848,748)",
    d: "m0 0v3l-4 5-4 7 1 5 2 5 5 5 4 5v2l-13 3-9 1h-33l-23-3-23-5-10-4 1-2 28-2 33-5 9-3 13-4 16-8z",
    fill: "#816BD5"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1034,728)",
    d: "m0 0 5 1 13 4 2 1-2 9 12 3v3h2l2 17-5 4-3 3v9l6 4-1 8-5 14-1 1h-11l-2 4-3 3-19-6 2-5 4-6 4 1 5 2 3-10 4-12-7-1-1-3 1-11 7-5h2l-4-19-8 5-2-1v-2l-4-2-1-2z",
    fill: "#1A60B3"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(520,308)",
    d: "m0 0h16l1 5v13l-1 19v12l1 19-1 4v16l3 7 2 3v6l-1 2-4-1-1 1-27 3-3 2 2-4 16-12 7-4 2-8-5-2-6-7h-2l-3-13v-14l2-6v-10l-1-6v-16z",
    fill: "#FBA19A"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(799,317)",
    d: "m0 0h7l8 4 5 2h22l5-1 3 2v2h2l2 4v9l-1 7-5 10h-2l-2 4-5-1-4-7-3-10h-14l-6 7-4 1v2l-10-1-7-4v-2l-4-2v-2h-2l-1-2v-9l4-6 5-4z",
    fill: "#F7ACA5"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(728,242)",
    d: "m0 0h1l1 17 4 8 2 7v13l-3 10-5 10-2 2-9-1-6-3-4-5-4-14-4-22v-8l5-6 5-3 9 1 8 5 1 1z",
    fill: "#F39D9E"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1093,430)",
    d: "m0 0 13 2v13l5 1 5 5 1 5 10 8 4 6-2 5-6 8-6 2-10 4-1-11-1-2-5 4 1 6-4 1-11-7-2-6 1-5 7-12h-1l-8 7-3 2-3-2 2-6 8-16z",
    fill: "#80B8D3"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(409,528)",
    d: "m0 0 3 1 1 8-4 1 17 42 1 7-2 4h-2l-1 5-4 2-3-3v-2h-2l1 7-2 2-3-1-13-25-12-22-4-9v-3l16-6 12-7z",
    fill: "#9480D8"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1245,401)",
    d: "m0 0h63v28l-2 1v-3l-49 1-10 1-1 2-1-12z",
    fill: "#77C6EE"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1020,723)",
    d: "m0 0 9 1 6 3-5 13 4 3v2l4-1 6-4 2 6 2 9v5l-8 5h-2l-1 3-6-2h-2v-2l-5-1-1 2-3-5v-2l-10-1-7 4-3 3-9-3h-3l3-10-1-14h2l1-3 6-3 4-4 5-1 6 4h3l1-3h2z",
    fill: "#1CB2DF"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1170,401)",
    d: "m0 0h63v26l-1 2-4-1h-54l-3-1-1-5z",
    fill: "#76C5ED"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1320,401)",
    d: "m0 0h62v27h-51l-11 2z",
    fill: "#76C5ED"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1327,336)",
    d: "m0 0h69l8 4 6 8 1 3v25l-1 16-1 71-2 41h-1v-49l2-72v-33l-4-7-8-4h-73l-293 2-78 1-8 4-4 7v31l1 18 1 46 1 27 1 13 2 54v25l-2-2-1-12-1-27-1-46-1-28-1-13-2-55v-32l4-7 5-3h2v-2l3-1 222-2z",
    fill: "#877BD4"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(278,662)",
    d: "m0 0 3 2h41l5 2-6 8-9 10-2 3h-2l-1 4h-2l-2 4v4l11 9 14 12h-3l-2-1v-2l-5-2-6-1-2-5h-28l-2 4h-1l-2-35v-14z",
    fill: "#EF7BF4"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(844,154)",
    d: "m0 0h8l6 7 3 9 1 10 10 15 1 11-5 12-8 17-2 9h-9l-3 3-2-1 4-10h2v-3h2l2-5 3-2-1-7-5-10-4-1-3-27-4-15-2-4h-28l1-2 12-1 5-2z",
    fill: "#175EB2"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(668,1010)",
    d: "m0 0 3 4v4h5l3 5 2-6 2 4 5-3 1-4 3-1 2 5 4 1 1 6-9 31-3 10h-29v-10l7-35 2-5z",
    fill: "#5D4CB9"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(998,441)",
    d: "m0 0h9l7 3 7 6 3 6 1 8-2 9-5 7-10 5h-12l-8-5-6-7-2-7 1-10 4-7 7-6z",
    fill: "#FEFEFE"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(756,902)",
    d: "m0 0 7 6 9 19 12 28 13 37 7 23v5h-3l-4-4-5 7-2 3-4-11-9-36-7-26-6-20-7-25z",
    fill: "#5335A4"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(673,984)",
    d: "m0 0h2l-1 3-70 1-11 1v3l2 1v2h-8v-2l-5 1 1 2 3 3 3 1 1 9-2 7h2l-1 8h-2v12l2 1-2 11-4 3h-3l-2 9 6 2 1 4h-14v-34l3-30 2-12-1-2-171-1v-1l265-1z",
    fill: "#6755BC"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(688,900)",
    d: "m0 0 7 6 4 4-1 5-6 18-1 6h3l1-2 10 5 1 3-11 29-9 27-6 22-2 1-2-6h-5l-2-5v-7l6-23 6-5 2-6h3l1-33v-17z",
    fill: "#5032A2"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1106,369)",
    d: "m0 0 10 2 7 6 4 7v12l-3 6-8 7-5 2h-9l-8-3-6-7-2-4v-14l4-6 7-6zm14 9 1 10 2 1 1-7-2-4z",
    fill: "#FDFDFD"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1143,772)",
    d: "m0 0h165l6 2 9 4 6 7 3 8v27l-3 90-4 9-6 7-9 4h-176l-8-4-5-4-5-9-2-33-1-42-1-14v-31l4-9 5-6 8-4zm-11 3-10 5-6 7-2 5v32l3 85 3 8h2l1 4 6 5 8 3h170l10-4 5-4 4-8 1-3 1-14 2-77v-26l-4-9-7-6-7-3z",
    fill: "#AF65AE"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(942,569)",
    d: "m0 0v3l-12 21-9 19-6 19-3 10-1 7-2 1-3-1h-8l-4-2-2 7h-3l-2-6v-8l-2-6h1l1-31 7 3h15l1 3 8-1v2h3l2-10 8-15 6-9 1-3h2v-2z",
    fill: "#806AD5"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(822 1e3)",
    d: "m0 0 2 3 7 20 8 21 4 13 2 8h-29l-7-34-1-7 3-5 5-3v-7l2-5z",
    fill: "#5747B6"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(814,406)",
    d: "m0 0 5 5 11 8 17 9 14 7v3l-49 16-14 6 2-6 7-15 5-19z",
    fill: "#8A70D3"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(486,373)",
    d: "m0 0 10 1 3 26 2 8v6l-5 5-5 1-2-1-2 5-3 2-5-1-6-7-6-13-3-12 9-7 5-2v-7z",
    fill: "#FBAEA2"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(998,425)",
    d: "m0 0h9l13 4 9 6 4 5 7 13v8l-2-2-6-2-6-1-4-6-4-2-7-5-4-1h-9l-9 4-4 4h-4l-2 6-4 1-2 2-7-1v-8l6-10 5-6h2l1-3 13-5z",
    fill: "#6DBBEC"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(909,182)",
    d: "m0 0 11 1 16 4 17 3 5 1-1 5-6 7-13 17-9 12-3-1-6-17-4-9-4-12-3-8z",
    fill: "#B099EB"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(738,515)",
    d: "m0 0h24l35 2 13 2-1 2 1 2 11 1v1h-24v2l-3 3-1 14h-1l-1-13-1 18h-8l-1-22h-2l-1 4-4 1v-3h-14l-1 3h6l14 4 1 1v8l-3 2h-25v-5h20v-4l-18-2-4-3v-10l-12-3-4-3z",
    fill: "#7757B7"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(573,437)",
    d: "m0 0h1l1 21 4 20 5 17 4 11 4 8 7 9 3 11 2 10-11-6-15-9 2-3-1-4 6-12-12-12-10-15-3-5 1-8 6-21 4-10z",
    fill: "#8A6FD3"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(685,724)",
    d: "m0 0 4 1 18 11 16 7 13 4 22 3h13l22-3 17-5 12-5 11-6 3 1-8 7-17 9-21 6-19 3-11 1h-28l-18-3-20-6h-3l1-5h3l6-2 1-4h-4l-2-5-4-2-3-1z",
    fill: "#826CD6"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1109,500)",
    d: "m0 0 5 2 4 2 2 3 8 2-2 4-7 9-12 13-10 9-11 7h-12l-11-4-16-9-4-3v-2l3-1h61l-1-5 1-17 1-1v-8z",
    fill: "#84C5DC"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1076,419)",
    d: "m0 0 5 2 9 6 4 2-9 19-7 14v2l3 1 8-8 5-3-2 4-6 11-1 5 1 5-6-2-6-4-6-2h-10l-4 4-6 7-1 7-6-3 5-5 6-7 10-21 11-26z",
    fill: "#6DA2D6"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(292,628)",
    d: "m0 0h141l9 3 7 7 2 5v27l-2 62h177v1h-178l-1-4v-22l1-38v-25l-2-5-5-5-7-3h-143l-8 4-4 5-2 7 2 69 1 20 3 9 6 5 5 2 84 1 2 2h-80l-10-2-8-5-4-8-1-4-1-19-1-46v-28l4-8 6-5z",
    fill: "#9B77D0"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(739,897)",
    d: "m0 0h14l5 11 6 20-1 3-8 1-24 1-8 1 4-17 5-17 2-2z",
    fill: "#23ce6b"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1170,552)",
    d: "m0 0h212v5h-212z",
    fill: "#6EBCED"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1170,545)",
    d: "m0 0h212v5h-212z",
    fill: "#6EBCED"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1171,590)",
    d: "m0 0h211v5h-212z",
    fill: "#6CBAED"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(651,638)",
    d: "m0 0 4 2 15 10 11 7 6 4 9 11 11 10 16 12 15 9 21 10 8 3v1l-10-1-16-5-17-7-18-10-19-14-7-7-8-7-9-11-8-10z",
    fill: "#8879DF"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1170,560)",
    d: "m0 0h204v5h-204z",
    fill: "#6EBCED"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1253,351)",
    d: "m0 0h145v7h-145z",
    fill: "#F5FBFB"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(689,886)",
    d: "m0 0 5 2 14 9 5 4 7 4 2 4-9 19-5 11-1 4-5-2-7-3-5 2 2-10 6-17-1-4-9-9z",
    fill: "#412288"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1182,567)",
    d: "m0 0h200v5h-200z",
    fill: "#6EBCED"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1290,791)",
    d: "m0 0h5l1 26 1 3 7-2 1 1h11l7-3 5 2 1 4v17l-2 5-4 2-17 1-2-1-8 2v5h-1l-1-13v-48z",
    fill: "#F07AF4"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(571,556)",
    d: "m0 0 3 2 3 12 4 14 3 19 1 17 2 1 2 3 1 4h-2v3h-2v3h-2l-1 4h-2l-1 4-3 2-3 5-17 17-10 8-10 7-9 5-8-1-8-6-1-6 6 1 2 3v-2l5-2 8-2 7-3 4-1v-2l-2 2v-2h-3l1-2 3 1-1-3 2-1 3-5 4 2 1 2h4v2l3-2-1-3 3-2 1 3h2v-3h2l1-2 5-2v-3h2v-3h2l4-17v-28l-6-31z",
    fill: "#8C7CE2"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(863,856)",
    d: "m0 0 4 5 11 23 10 24 9 24 8 24 6 23 5 21 5 30 1 24h-1l-7-36-4-13-1-8-3-9-4-17-3-8-2-7-4-15-4-10-5-17-3-7-4-12-11-28-3-8z",
    fill: "#6EBDEE"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(834,702)",
    d: "m0 0 2 1-2 12-2 7-8 6-16 8-14 4-23 3h-24l2-2 16-4 20-6 23-11 16-10z",
    fill: "#816BD5"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(806,396)",
    d: "m0 0 4 1 4 7v10l-4 19-5 13-8 15h-22l-1-2h2v-2l7-6 1-2h2l2-5 3-5 4-8h2l2-11 3-15 1-2h2v-6z",
    fill: "#6F4FB0"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(802,165)",
    d: "m0 0h9l3 2-2 10-3 5-11 2-30 4h-9l-8-1-1-3 8-6 3-4 11-4 19-4z",
    fill: "#457EDF"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1324,791)",
    d: "m0 0 2 1 1-1 3 2v26l-2 3-3-6-9 4h-11l-2-1-7 1h-1v-28h25z",
    fill: "#F586F7"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(745,523)",
    d: "m0 0h5l2 4 1 7 1 1 18 3v4h-20v5l25-1 3-1-1-8-14-4-6-1 1-4 14 1 1 2 3-1 1-3h2l1 2v20h8v-21l2 3v13h2v3l8 2 19 1v1h-24l-1 1h7l3 2h-31l-83-1v-1l51-1v-3-1h6v-6l-20-1 1-4 10 1v-5h-11v-3h14v3l5-2 1-6z",
    fill: "#7351B2"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(508,257)",
    d: "m0 0h3l5 5 8 6v2l9-7 8-6 6 8-2 4-6 5h-2v2l-2 2 8 6v2l3 1-1 5-3 4-4-2-6-4v-2l-4-2-4-1-13 10h-3l-4-5 2-4 9-8 1-2-5-2-9-7 5-7z",
    fill: "#FDFDFD"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(598,524)",
    d: "m0 0 4 2 14 11 10 8 7 8 10 9 3 3-9 3-13 4-3-3-4 7-2-8-3-5-3-3v-2h-2v-3h-2l-3-11-5-1v-2l4 1 2 1-4-16z",
    fill: "#5847B5"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1328,839)",
    d: "m0 0h1v19l-1 13-2 2-11-1-9 1-6 3h-4l-1 2v-25l1-5 9-3 3 1 16-1 3-2z",
    fill: "#EA6AF0"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1010,756)",
    d: "m0 0h6l4 2 4 7v2h-2l-2 4-4 6-3 9v12l-4 3-7 1-5-3-4-6-1-10 2-9 4-8 6-7z",
    fill: "#175DB1"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1028,541)",
    d: "m0 0h2l1 2 3 21 6 18 5 9-1 5-8 12-3 1-7-16-4-11-2-10-1-11v-11l3-3h2l2-4z",
    fill: "#77C6EE"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1184,896)",
    d: "m0 0h110v8h-110z",
    fill: "#C157E2"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(291,630)",
    d: "m0 0h123l2 3-2 2h-5v-2l-74 1-4 1h-7l-2 4-1 5-41 1-3 1 1-6 6-7z",
    fill: "#F98FF7"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(385,678)",
    d: "m0 0 5 1v2l6 2 11 12-1 3-5 4h-2v2l-4 2-2-1-23-1-5-1-4 6-4 1 2-5 12-24 5-2v2h2l1-2z",
    fill: "#E56CEE"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1103,352)",
    d: "m0 0h8l13 4 8 6 7 8v1h-6-3l-14 1-10-2-12 2-20-1 2-4 5-6 10-6z",
    fill: "#6EA2D7"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(699,256)",
    d: "m0 0h1l2 10h1l4 23 1-23 1-2 6 1 4 4-3 8v11l3 5h4v-12l3-1 3 1-1-7h3l1 2 1-6 2 1 1 3v13l-3 10-5 10-2 2-9-1-6-3-4-5-4-14-4-22z",
    fill: "#F8ABA3"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1142,815)",
    d: "m0 0 3 2v32l-2-3-4 1h-18l-2-1-1 3h-2l-1-6-1-24 3-2 9 1 2 1h8l4-3z",
    fill: "#F07AF4"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1171,598)",
    d: "m0 0h211v4h-212z",
    fill: "#6CBAED"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1145,791)",
    d: "m0 0h7v1h-6v71l-1 13-5-3-4-1h-8l-9 2-1 2-2-9-1-10v-14h1v6l3-3h20l3 1 1-2 1 1z",
    fill: "#EA6AF0"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(767,271)",
    d: "m0 0h5l12 5 12 3-1 3h-2v2l-5 1-4-2v-3h-8l-3-4-4 1-3 4-1 5 8 16 2 11-1 3h-7l-9-7-3-4v-2l-3-1v-3h-2l-1-5-3-7v-9l4-2 5 3 11-7z",
    fill: "#FAA19B"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(844,241)",
    d: "m0 0h2l-1 5 4-3h8l2-1-2 12-2 16 2 2h-4v11l-2 3h-5l-1 4 4 8-1 7-7 4-9 1-16-4-4-4h11l9 1h15l-5-14-4-8-2-3 4 2 3 1 1-7-7 1v-8l4-15v-6z",
    fill: "#E17BA2"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(347,679)",
    d: "m0 0h7 3l1 3-4 9-1 5-11 25-1-4 3-8-8 4-1 8h-2l-1-11-10-9-7-6 2-5 6-3v2l13-1 1-7z",
    fill: "#E66CEE"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(529,451)",
    d: "m0 0 1 3-4 9-1 7h-2l-1 5-4 5h-3v3l-3 3-11 6-11 4h-5l-1-22 12-2 9-4 11-7 7-4z",
    fill: "#E37BA1"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(450,776)",
    d: "m0 0h135l1 1v5h-136z",
    fill: "#23ce6b"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(350,487)",
    d: "m0 0 2 1 1 3 8-1 8 20 2 7 9 3 8 1v1l-8 2-6 1v2l-5 3-6 3h-4l3 3-4-1-5-6-5-17v-16z",
    fill: "#7B68D1"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1068,390)",
    d: "m0 0h17l3 9 4 6 6 4 8 2v17h-9l-9-3-2-1v-2h-3v-2l-5-1-5-10-2-2-3-12z",
    fill: "#70A2D7"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(407,679)",
    d: "m0 0h11l7 1h21l2 3v24l-1 6-2-4v-5h-24l-2-1-3 1v-2l4-4-10-11-3-6z",
    fill: "#E86BEF"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1182,583)",
    d: "m0 0h200v4h-200z",
    fill: "#6CBAED"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1182,538)",
    d: "m0 0h200v4h-200z",
    fill: "#6CBAED"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1182,523)",
    d: "m0 0h200v4h-200z",
    fill: "#6CBAED"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1144,791)",
    d: "m0 0h1v26l-3-1-5 4h-9l-2-1-9-1-2 2-1-1v-22l6-5h22z",
    fill: "#F586F7"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(520,308)",
    d: "m0 0h16l1 5v13l-2 38-2-1-5-15v-2l-8 3-3-16v-16z",
    fill: "#E57DA1"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(386,470)",
    d: "m0 0 10 5 12 11 7 10 2 4v13h-1v-7l-7 4-6 3h-9l1-9-1-5h-2l-10-18v-2l6-2z",
    fill: "#7A67D1"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(879,516)",
    d: "m0 0 2 2 3 11 1 14 1 33v25l-1-2-3 1v-2l-8-1v6l-2 4-3-10 1-7 2-1 3-25 2-27 1-4z",
    fill: "#5747B6"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(951,339)",
    d: "m0 0h225v1l-146 1-78 1-8 4-4 7v31l1 18 1 46 1 27 1 13 2 54v25l-2-2-1-12-1-27-1-46-1-28-1-13-2-55v-32l4-7 5-3h2v-2z",
    fill: "#707ACD"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(728,413)",
    d: "m0 0 3 1v2h2l7 9 12 7 16 5 7-1 10-4 8-6 3-3 3-7 1 4-3 11h-2l-2 6-7 9-10 5h-8l-10-4-11-8-8-8v-2h-2l-9-14z",
    fill: "#AE98EA"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1030,340)",
    d: "m0 0h118v1l-22 1h10 3 6l-1 2h-5v5l4-1 2 4-2 13-1 2h2v3l2 1-4-1-6-8-7-6-14-6h-16l-6 1-3-9-60-1z",
    fill: "#719FD8"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(389,662)",
    d: "m0 0 5 5 9 10 9 11 9 10-5 5-12 11-10 8-5 3v-14l8-7h2v-2l7-5-2-4-9-10-8-8v-7z",
    fill: "#FBFDFC"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(812,349)",
    d: "m0 0 2 1v2l4-3 3 1-2 1 1 3-8 3-2 3-1 2 8 1v-3h2v-2l9-1 4 2 2 3v3h-2v3h4v-2h2l-2 4-2 3h-2v-3h-23l-7 1-13-1h-8l-2-4 13-1-13-1-5-3 2-1v-4l-3-1 7 1 4 2v5l7-1 1-5h-6v-4l2-1 7 3 10-1 1 2z",
    fill: "#5445B3"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(998,441)",
    d: "m0 0h9l7 3 7 6 3 6 1 8-2 9-5 7-10 5h-12l-8-5-6-7-2-7 1-10 4-7 7-6zm1 5-8 1-2 4-3 1-2 8h2l-1 2v10l4 3h6l4 1 5 1 3 1 6-2 1-3h2l1-5h2l2-5-4-2-3 1v-13l-4-2z",
    fill: "#F5FBFB"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(222,551)",
    d: "m0 0 10 1 7 8v12l-5 7-4 2h-11l-5-3-4-7v-10l4-6 4-3z",
    fill: "#9684E8"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(331,661)",
    d: "m0 0h1v13l-9 11-4 5h-2l-1 5 13 12 4 3v14l-6-4-15-13-11-9 2-4 2-3h2l1-4 5-5 9-10z",
    fill: "#FDFCFD"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1406,505)",
    d: "m0 0h1v24l-1 62-2 19-4 6-5 4-2 1h-436l-5-3-4-5-1-7 6 9 6 4h432l8-5 3-6 1-26 1-46 1-24z",
    fill: "#5567BA"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(368,663)",
    d: "m0 0h12l-2 6-11 22-10 19-8 15h-8l-1-2 16-35 10-23z",
    fill: "#23ce6b"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1171,575)",
    d: "m0 0h171v4h-171z",
    fill: "#6CBAED"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1037,538)",
    d: "m0 0 4 2 3 4v2h2l8 11 9 11-7 11-5 6-4-2v-2h-2l-5-10-1-3-2-1-2-10-2-8 1-6z",
    fill: "#84C5DC"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(575,564)",
    d: "m0 0 3 1v2h3l5 7 3 5 6 8-1 3 2 8 5 2 1 1-1 7-2 5h-2l-2 7h-2l-1 5-5-1-2-3h-1l-2-27-5-22-2-5z",
    fill: "#6F59BB"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(832,581)",
    d: "m0 0 13 1 28 5-1 3h-2l-1 7-4 4-5 8-3 1-10-8-18-11v-2h2z",
    fill: "#9480D8"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(759,774)",
    d: "m0 0h11l8 1v1h19l14-1v2l2 1-1 9 2 2h-17l-23-3-23-5-10-4 1-2z",
    fill: "#8879E1"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(668,1010)",
    d: "m0 0 3 4v4h5l3 6-1 8-6 27-1 7h-13v-10l7-35 2-5z",
    fill: "#5747B5"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(446,732)",
    d: "m0 0h1l-1 10-7 8-5 3h-54l2-8 4-6 4-2-1 3 2 1 5 1 3-1h13l15 2 6 1h5l2-4 3 1 2-6-1-2z",
    fill: "#B163AD"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(675,578)",
    d: "m0 0 99 1v1l-37 3-31 4-20 4-16 6-6 3v-3h2l2-5 6-10 3-3z",
    fill: "#927ED7"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(549,497)",
    d: "m0 0 3 4 2 5 3 18v28l-3 13-7 14-9 12-8 7-5 2 3-5 9-14 5-11 5-17 3-18v-25z",
    fill: "#8879E1"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(860,186)",
    d: "m0 0 3 2 1 10 6 1 1-3 2 4v6l-5 12-8 17-2 9h-9l-3 3-2-1 4-10h2v-3h2l2-5 3-2-1-7-5-11 6-13z",
    fill: "#174194"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(844,818)",
    d: "m0 0h1l1 11-16 8-21 6-30 5-11 1h-13v-2h-11l-2-1v-3h-6v-1l45-2 22-3 19-4 14-4h3l2-5z",
    fill: "#7864CE"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1246,401)",
    d: "m0 0h62v13l-1-3-50 1-8 1-3-1z",
    fill: "#6CBAED"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(486,373)",
    d: "m0 0 10 1 2 19v7l-11-1-3 1 1 9-3-4-1-6-10 1-5 2-1-5-1-4 9-7 5-2v-7z",
    fill: "#F99D9B"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1007,820)",
    d: "m0 0h3l2 10 14-10 9 2 10 3v4l-13 9-8-1-5-1-3 6-12-3-7-3-1-3 3-10z",
    fill: "#1B5DB1"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(762,461)",
    d: "m0 0h34l-6 8-8 8-8 5-6-2-11-6-12-8v-2l-2-1z",
    fill: "#937FD7"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(305,686)",
    d: "m0 0h3l-1 5h-2l-2 4v4l11 9 14 12h-3l-2-1v-2l-5-2-6-1-2-5h-28l-2 4h-1l-1-23 6-3h17v2h2v-2z",
    fill: "#E76CEE"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1320,401)",
    d: "m0 0h62v11l-51-1-6 2-5-1z",
    fill: "#6CBAED"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(749,185)",
    d: "m0 0h2v2h17l13-2 23 1 16 5 3 3-17-1-19-1h-24l-9 2-6 3-7 4-10 3h-8l-2-1 2-4 6-4 7-4 7-3z",
    fill: "#185CB1"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1034,728)",
    d: "m0 0 5 1 13 4 2 1-2 9 12 3v3h2l2 17-14-4-6-2-4-19-8 5-2-1v-2l-4-2-1-2z",
    fill: "#216BD5"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1171,401)",
    d: "m0 0h62v8l-1 3h-56l-5-1z",
    fill: "#6CBAED"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(857,271)",
    d: "m0 0 2 2h-5l2 12 8 17v12l-2 7-1 4v-2l-5 1v-2h-2l-4-6-6-2-21-3v-1l18-2 6-3 1-7-4-8 2-4h5l1-9 1-5z",
    fill: "#F4AAA6"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(451,838)",
    d: "m0 0h121v5h-121z",
    fill: "#23ce6b"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1020,448)",
    d: "m0 0 3 1 2 5 4 2h6l5 5v11l-5 13-9 10h-2v-4l-3-1-4-5-2-1 1-4 4-4 3-6 1-9-3-9z",
    fill: "#77C5ED"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(643,619)",
    d: "m0 0 10 2 3 5 7 2v2l4-3 9 19 8 12h-3l-16-10-15-11v-2l-4-2-4-3v-2l-4-2v-4z",
    fill: "#816BD5"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(804,311)",
    d: "m0 0h12l21 1 9 2 5 2 3 4v2h2v2l5-1-3 15-2 3-3-12-2-4-2 1-3-3-5 1h-22l-9-4-4-4-3-2 2-1z",
    fill: "#1A4498"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(725,420)",
    d: "m0 0 4 2 3 3 3-1 2 5h2l7 8 9 7 10 5 3 1h8l8-4h2l2-4 3-2-2 4-3 5h-2l-2 4-4 4h-2l-1 4h-12l-13-9-10-9-8-9-6-9z",
    fill: "#7C69D2"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1143,772)",
    d: "m0 0h165l6 2 2 2h-184l-14 7 2-4 6-4 7-2z",
    fill: "#C894C5"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(451,849)",
    d: "m0 0h93l1 5-1 1h-93z",
    fill: "#23ce6b"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(893,643)",
    d: "m0 0 2 3 4 1h7l5 1 1 23 2 14 3 7-4-2-8-9-10-16-5-10z",
    fill: "#8A7AE1"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(690,835)",
    d: "m0 0 31 4 13 1 31 1v1l-23 1v3h8l5 1v2h-45l-16-2-4-2z",
    fill: "#806AD4"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(624,572)",
    d: "m0 0 7 6 6 5 7-1h4l18 3 4 2 2-1-2 5-4 6h-2v4l-4 1-15-8v-2l-6-2-2-2-8 3-1 5v8h-1l-2-17z",
    fill: "#6252BB"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(451,814)",
    d: "m0 0h108l1 5h-109z",
    fill: "#23ce6b"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(852,634)",
    d: "m0 0h1l-1 10-11 64-1 9v9l4 7 7 9 1 6-5 7h-2l2-4 1-3v-3h-2l-1-3-5-5-6-8-1-3v-11l2-12 2-5 6-30 4-15 4-18z",
    fill: "#66BEED"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(864,438)",
    d: "m0 0 5 1 20 12 11 8 13 10 5 6 2 6 4 24 7 34v6h-1l-2-9-3-8-3-12-2-14-4-16v-3h-2l-6-8-4-3v-2l-4-2-7-6-2-1v-2l-4-2-10-8-2-1v-2l-4-2-7-5z",
    fill: "#71C2ED"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(773,331)",
    d: "m0 0 4 1h4l1 10 4-1 4 4v2l6 2 5 2 6 1v-2l6-4 4-5 3 1 1 1h7l1 5h-4v-3l-4 3h-2l-3 4h-2l-2-2-6 7-2-2-9 1-7-3-2 1v2l6 1 1 4-2 2h-7l-1-5-6-2v-2l-4-4 2-1-3-2-1-9z",
    fill: "#303391"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(848,748)",
    d: "m0 0v3l-4 5-2 4-4 1-1 4-8 4-12 4-20 4h-22v-1l-5-1v-2l33-5 9-3 13-4 16-8z",
    fill: "#7966D1"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(396,733)",
    d: "m0 0h48l2 3-2 5h-3l-1-1-1 4-2 1h-7l-8-2-10-1h-15l-5 1-3-2 1-5z",
    fill: "#BF58DC"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(850,324)",
    d: "m0 0 3 2 3 10-1 9-8 19-2 5-6-1v-2h-3v2h-4v-3h2l-4-7h-11v2h-2v3h-8l-1-2 4-5 7-3 1-3-2-2 4-1-2-2h5v3h4l-1-4h-10l2-3h11l3 7 3 8 2 3 5-1 4-5 3-7 1-7v-9z",
    fill: "#2E3390"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(593,99)",
    d: "m0 0 3 1 12 25 4 8-9 5-5-1-11-23-3-6 2-4z",
    fill: "#B667AC"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(723,523)",
    d: "m0 0h22l4 1v6l-6 2v-3h-14v3h11v5h-10l-1 3h18l2 1v6h-21l-7-1 1-21z",
    fill: "#23ce6b"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(627,610)",
    d: "m0 0 3 3 4 7 6 7 10 8-1 30-3-4-1-5-1-10-2-4-1-3h-2l-3 7 4 1-2 6-2-2-1 1 2 8-1 7h-1l-6-35-2-17z",
    fill: "#9682DB"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(981,450)",
    d: "m0 0h3l-3 10 1 14 1 3 6 5 2 2-4 1-13 1h-2l-5-9-2-5-1-7v-8l2-4 1 3-1 2h7l2-2h4l1-4z",
    fill: "#77C6ED"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1032,525)",
    d: "m0 0 5 3 5 5 8 6 17 9 7 2-6 12h-2l-1 4-1 2-4-2-11-14-3-4v-2h-2l-6-9 1-5-4-2-3-3z",
    fill: "#6DA2D7"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(886,592)",
    d: "m0 0h1v42 3l1 2v8l-2-4h-2l-1-7h-2l-2-10h-2l-4-14-2-4 1-5h2l-1-4 1-2 8 1 3 1z",
    fill: "#6454BC"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1093,430)",
    d: "m0 0 13 2v13l-5 1v2l-8 7-12 11-4-2 2-6 8-16z",
    fill: "#6CBAED"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(509,260)",
    d: "m0 0 1 2 6 2 1 4 6 3 8-2v2l1-2h2v-2l-2-1h3l2-4 1 2 6-1v5l-2 2h-3v2l-5 4 1 8h2v3h6l1 3-7 1-2-2v-3l-5-1v-3l-3 1-7 1v2l-4-1v2l-4 1-3-3 6-2v-2l2-1-2-6-4-2v-2h-2l-3-3-1-4z",
    fill: "#F9FDFB"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(848,832)",
    d: "m0 0h5l4 3 3 6-10 4-47 15-4-1 22-12 21-12z",
    fill: "#5031A1"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(689,877)",
    d: "m0 0 6 2 8 4 9 4 14 8 5 3-2 4-6 5-5-2-10-7-11-7-8-5z",
    fill: "#361B7D"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(691,522)",
    d: "m0 0h22l5 3 1 2v11l-2 6-4 2h-13l-2-6 13-1 1-11h-15v17h-6z",
    fill: "#23ce6b"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(820,217)",
    d: "m0 0h3l-3 9-3 5-1 1-30 1-8 3-6 2 2-5 9-7 6-2 8-1 9-3z",
    fill: "#363390"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(802,723)",
    d: "m0 0 1 2 3 1v5l-4 6-4 2-17 3-10 1h-24l2-2 16-4 20-6z",
    fill: "#8879E1"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(958,562)",
    d: "m0 0h6l6 3v2l6 2-5 10-2 1 1-4-5 1-10 5-5 2h-3v6h-1v-24z",
    fill: "#5B99DE"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(588,508)",
    d: "m0 0 2 3 9 12 3 11 2 10-11-6-15-9 2-3-1-4 6-12z",
    fill: "#937ED7"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(669,994)",
    d: "m0 0h3l-1 9-3 13-2 5-7 35-1 10h-8l2-11 1-14 4-12 3-8 4-16 3-6 1-4z",
    fill: "#6151BA"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(692,778)",
    d: "m0 0 19 9 8 4 7 6-1 3h-15l-17-2-2-1z",
    fill: "#826CD6"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(529,467)",
    d: "m0 0h1v30l-5 10-13-5-12 1 5-4 8-7 9-12z",
    fill: "#9480D8"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(754,524)",
    d: "m0 0h26l-1 6-5 2v-3h-14l-1 3h6l14 4 1 1v8l-3 2h-25v-5h20v-4l-18-2-2-2v-8z",
    fill: "#23ce6b"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(793,383)",
    d: "m0 0 29 1 7 3v5l-1 1-26 1-23-5-10-4 4-1z",
    fill: "#361B7D"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(846,522)",
    d: "m0 0 18 1-1 25-1 10h-12l-4-4-1-3h8v-12l1-13h-7v7l-1 2-3-1v-2l2-1v-7z",
    fill: "#6754BC"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1119,458)",
    d: "m0 0 8 6 4 6-2 5-6 8-6 2-10 4-1-14 10-11z",
    fill: "#84C5DD"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(797,525)",
    d: "m0 0h24v6l-6 2v-2h-16l1 11 15 1v-6h5v12h-16l-10-2-1-3v-14l2-3h2z",
    fill: "#23ce6b"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(451,802)",
    d: "m0 0h68v6h-68z",
    fill: "#23ce6b"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(282,632)",
    d: "m0 0h2l-2 4-4 7-1 8 2 65 1 20 3 9 6 5 5 2 84 1 2 2h-80l-10-2-8-5-4-8-1-4-1-19-1-46v-28l4-8z",
    fill: "#AF7BC8"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(693,682)",
    d: "m0 0 7 3v2l10 1v-2l5 2 14 10 25 13 13 5v1l-10-1-16-5-17-7-18-10-12-9z",
    fill: "#896FD3"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(825,526)",
    d: "m0 0h11l8 16 3 3v-11l1-7h5v18l-1 5h-10l-5-8v-2h-2l-3-9h-2l-1 18h-5v-21z",
    fill: "#23ce6b"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(844,154)",
    d: "m0 0h8l6 7 3 9 1 10 10 15-1 3-4 1-3-1-2-10h-2l-4 12-4 7-1-2 4-16 1-16-3-12-2-4-12 4-29 1 1-2 12-1 5-2z",
    fill: "#4EB0E6"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(450,776)",
    d: "m0 0h135l1 1v5l-16-1h-49l1-3-71-1v5h-1z",
    fill: "#23ce6b"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1205,572)",
    d: "m0 0h129l-1 3h-129z",
    fill: "#80DBF7"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(943,568)",
    d: "m0 0h2v16l-7 8-10 16-10 25-3 8-1-4 3-16 5-13 9-19 10-17z",
    fill: "#B099EB"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(463,401)",
    d: "m0 0 2 1 5 13 4 5 1 6-5 5h-6l-8-9-3-7v-6z",
    fill: "#FCAEA2"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(384,927)",
    d: "m0 0h1l1 24h1l1 21 2 4 5 5 5 3 269 1v1l-269 1-8-5-6-7-2-11z",
    fill: "#456ECD"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(571,556)",
    d: "m0 0 3 2 3 12 4 14 3 19 1 17 2 1 2 3 1 4h-2v3h-2v3h-2l-1 4h-2l-1 4-6 4 3-10 2-9v-28l-6-31z",
    fill: "#816CD5"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(424,636)",
    d: "m0 0h6l2 6 8 6 8-2 1-2v14l-3 1h-8l-8-3-4-3v-2h-2l-4-8v-6z",
    fill: "#EA6AF0"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1057,137)",
    d: "m0 0h1l5 87h-5l-1-3-3-65v-17z",
    fill: "#2C6EBC"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(702,256)",
    d: "m0 0h8l8 4 6 6 3 8v4l-4 2-1 2-4 2-2 2v-10l2-8-5-3-4-1-1 28-2-3-4-24z",
    fill: "#E67BA1"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(777,883)",
    d: "m0 0h2l-3 10-2 5-2 19-2 3-8-14-7-6 2-4 18-12z",
    fill: "#361B7D"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(478,920)",
    d: "m0 0h70v5h-70z",
    fill: "#23ce6b"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(479,885)",
    d: "m0 0h69l1 5h-71z",
    fill: "#23ce6b"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1081,912)",
    d: "m0 0h6l4 5-1 5-14 10-4 3-4-1-4-7 1-5 13-8z",
    fill: "#5C4BB8"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(794,433)",
    d: "m0 0 1 3-1 2h2l1-3 1 2-1 5 3 6v8l-3 5h-22l-1-2h2v-2l7-6 1-2h2l2-5 3-5z",
    fill: "#7059BB"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(745,523)",
    d: "m0 0h5l2 4 1 7 1 1 18 3v4h-20v5h25v1h-26l-1-6-3-1-18-1 1-4 10 1v-5h-11v-3h14v3l5-2 1-6z",
    fill: "#8768C3"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1068,390)",
    d: "m0 0h17l3 11-4 7-6 8-4-5-3-4-3-12z",
    fill: "#6DBAEC"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(730,902)",
    d: "m0 0h1l-1 7-5 21-4 15-3 1-1-5h-2v-2l-4-1-1 2 1-6 11-24 5-5z",
    fill: "#44268C"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(863,856)",
    d: "m0 0 4 5 11 23 10 24 9 24 4 11-1 4v-3h-2l-4-10-2-9-3-1-1-4-1 3-6-16-4-12-11-28-3-8z",
    fill: "#68BAEC"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(643,714)",
    d: "m0 0 4 2 10 10 7 5v1h-33l1-6 4-6z",
    fill: "#B19AEC"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(451,908)",
    d: "m0 0h67v5h-67z",
    fill: "#23ce6b"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(451,873)",
    d: "m0 0h67v5h-67z",
    fill: "#23ce6b"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(451,791)",
    d: "m0 0h67v5h-67z",
    fill: "#23ce6b"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(951,339)",
    d: "m0 0h225v1l-146 1-78 1-8 4-4 6-1-3 2-4 5-3h2v-2z",
    fill: "#6469C3"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(498,861)",
    d: "m0 0h67l-1 5h-66z",
    fill: "#23ce6b"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(498,896)",
    d: "m0 0h66v5h-66z",
    fill: "#23ce6b"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(853,584)",
    d: "m0 0 9 1 11 2-1 3h-2l-1 7-4 4-5 8-3 1-7-6 2-5z",
    fill: "#8A70D4"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1099,349)",
    d: "m0 0h16l14 6 10 9 4 7-3 1h-23v-1h13l1-2 7 1-9-10-10-5-8-2h-8l-12 3-10 6-7 9h20v1h-21l-3-2 6-8 8-7 8-4z",
    fill: "#76C8F0"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1138,472)",
    d: "m0 0 5 3 2 4-1 7-7 11-12-3-2-2v-5l3-1 2-4 8-9z",
    fill: "#85C6DD"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1170,530)",
    d: "m0 0h65v5h-65z",
    fill: "#6EBCED"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(829,820)",
    d: "m0 0h6l-1 2-20 4-28 4h-25l-1-3-3-2 23-1 3-1 40-2z",
    fill: "#7C69D3"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(526,802)",
    d: "m0 0h53l1 5-1 1h-52l-1-1z",
    fill: "#23ce6b"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(409,528)",
    d: "m0 0 3 1 1 8-4 1-1 4-9 1-6 4-1 3 3 6-1 3-5-5-6-2-3-7v-3l16-6 12-7z",
    fill: "#7159BB"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(456,782)",
    d: "m0 0h131l1 4-2 1-3-1-32-1h-24l-4 2v-2h-67z",
    fill: "#5B6FC9"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(677,579)",
    d: "m0 0 22 4 8 1-1 3-20 4-16 6-6 3v-3h2l2-5 6-10z",
    fill: "#7A67D0"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(573,437)",
    d: "m0 0h1v13l-1-3h-2l-1 9v3l2 2-2 12v16l-2 2-8-13 1-8 6-21 4-10z",
    fill: "#8979E0"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1060,454)",
    d: "m0 0 1 3-8 17-8 9-6 3-1-3 4-8 1-20h3v2l4-1 8 3z",
    fill: "#76C5EE"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(673,984)",
    d: "m0 0h2l-1 3h-91l1 3-4 2-2-1-1 4-2-7-171-1v-1l265-1z",
    fill: "#594AB7"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(756,902)",
    d: "m0 0 7 6 9 19 4 9-1 4h-3l3 6-2 2-5-1-9-32-3-10z",
    fill: "#391E80"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1146,896)",
    d: "m0 0h38v8h-38z",
    fill: "#23ce6b"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1396,337)",
    d: "m0 0 5 1 6 5 4 8v25l-1 16-1 71-2 41h-1v-49l2-72v-33l-4-7-8-4z",
    fill: "#7682D2"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(419,630)",
    d: "m0 0h15l9 4 5 6v6l-6 3-4-2-6-4-2-4v-2h-10l-1 4z",
    fill: "#F486F7"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1316,776)",
    d: "m0 0 6 1 7 8 3 8v27l-3 90-4 9-6 7v-3l5-7 2-6 1-14 2-77v-26l-4-9-6-5z",
    fill: "#AE6BB6"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(213,568)",
    d: "m0 0h26l-1 6-4 5-4 2h-11l-5-3-3-4v-5z",
    fill: "#619DDF"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1093,354)",
    d: "m0 0h3l4 10v3l-4 4h-22l2-4 5-6 10-6z",
    fill: "#5C9ADD"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1008,295)",
    d: "m0 0 3 3 3 7v3l-5 3h-2v2l-5 1v2l-5 1-4-8v-2h-2v-3l8-4h2v-2z",
    fill: "#5D4BB8"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(549,497)",
    d: "m0 0 3 4 2 5 3 18v28h-2v-3l-5 1-2 3 2-18v-25z",
    fill: "#8A6FD3"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(799,317)",
    d: "m0 0h7l8 4 5 2h22l5-1 3 3-6 2-8 5-7 1-10-3-11-7-3-3-5-2z",
    fill: "#E37AA1"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(847,277)",
    d: "m0 0 1 2h-2v5l4-1 2-2v3l-1 2h-5l-1 4 4 8-1 7-7 4-9 1-16-4-4-4h11l9 1h15l-5-14-4-8-2-3 4 2 3 1v-3z",
    fill: "#E279A1"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1034,728)",
    d: "m0 0 5 1 13 4 2 1-1 5-2 3-6 1-2-2-6 5-3-1v-2l-4-2-1-2z",
    fill: "#174597"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(451,814)",
    d: "m0 0h67v1l-19 2-2 2h-46z",
    fill: "#23ce6b"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(476,919)",
    d: "m0 0h1l1 6 71 1v3h-54l-18-1-2-1v-2l-4 1 1 3h-21l-1-3 20-1 1-2h4z",
    fill: "#467EDF"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1025,465)",
    d: "m0 0h1l1 8 8 9-1 4-8 9h-2v-4l-3-1-4-5-2-1 1-4 4-4 4-8z",
    fill: "#82B8D4"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(860,325)",
    d: "m0 0h1v9l-4 16-5 15-7 13-9 11-4 3-3-1 8-10 7-12 10-24 4-10z",
    fill: "#67B7ED"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(688,900)",
    d: "m0 0 7 6 4 4-1 5-6 18-3 7-2-1v-17z",
    fill: "#5B3DA6"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(608,363)",
    d: "m0 0h6l4 2 2 4v6l-4 5-7 1-5-3-2-4 1-7z",
    fill: "#B368AE"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(565,244)",
    d: "m0 0h2l4 7-1 19-1 34-2 5-2-1 1-1v-11l-1-1z",
    fill: "#B169B1"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(382,793)",
    d: "m0 0h1l1 19 1 60 1 31v58h-1l-2-55-1-70z",
    fill: "#5A58BD"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(879,516)",
    d: "m0 0 2 2 3 11v33l-1 1h-6v-14z",
    fill: "#5133A2"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1114,371)",
    d: "m0 0 5 2 6 7 2 4v12l-3 6-8 7-5 2h-9l1-2h10l2-10 6-2h2l-1-8 1-7-1-4h-2l1 9-6-5-1-2z",
    fill: "#23ce6b"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(458,764)",
    d: "m0 0 3 1v3h2v2h8l9-1h17l1 1 50 1v1l-85 2-4-1-6-1 1-6z",
    fill: "#516BC7"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(656,821)",
    d: "m0 0h3v2l13 1 9 1 6 3h1v7l-18-3-1-1-10-2-7-3 1-3z",
    fill: "#3761CC"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1173,735)",
    d: "m0 0h6l4 3 1 8-3 5-2 1h-6l-4-2-2-4 1-7z",
    fill: "#7152B3"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(762,461)",
    d: "m0 0 6 1 5 2 1 2v11l-5-1-16-9-3-2h-4v-2l3-1z",
    fill: "#B19AEC"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(725,420)",
    d: "m0 0 3 3 7 8 5 5v2l4 2 9 8 14 9 4 2v2h-8l-13-9-10-9-8-9-6-9z",
    fill: "#7059BB"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1406,505)",
    d: "m0 0h1v24l-1 62-2 19-4 6-5 4-2-2 6-4 3-6 1-26 1-46 1-24z",
    fill: "#7F89D6"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(847,446)",
    d: "m0 0h1l1 6v25l-3 10-1-3h-6v2l-3 1 3-9 5-17z",
    fill: "#937FD8"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(451,896)",
    d: "m0 0h43v5l-43 1z",
    fill: "#23ce6b"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(451,861)",
    d: "m0 0h43v5h-43z",
    fill: "#23ce6b"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(674,404)",
    d: "m0 0h1l4 29 1 7-10-2-1-1 1-17z",
    fill: "#6F58BA"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(731,899)",
    d: "m0 0 2 1-2 3-5 4h-2l-2 6-10 21-11 28-10 29-8 26h-1l1-9 5-16 8-24 10-25 4-11 7-15 6-11z",
    fill: "#7560C8"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(814,166)",
    d: "m0 0 4 4 10 15 2 5h-3l-14-6-7-1 4-4 2-5 1-7z",
    fill: "#175EB2"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(848,748)",
    d: "m0 0v3l-4 5-2 4-4 1-1 4-8 4-8 1v-2l-7-1v-2l18-7 11-6z",
    fill: "#7059BC"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(393,499)",
    d: "m0 0 2 3 1 7-6 10-2 2h-8l-9-3-2-3v-3l6 1h10l6-9z",
    fill: "#B099EB"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(773,331)",
    d: "m0 0 4 1h4l1 10 4-1 1 3-3 3v3h-2l-1 3h-6l-2-3 2-1-3-2-1-9z",
    fill: "#5646B4"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(282,632)",
    d: "m0 0h2l-2 4-4 7-1 8 2 65v20h-2l-1-19-1-46v-28l4-8z",
    fill: "#AD6CBB"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(829,520)",
    d: "m0 0 18 1-1 4v6l-3 1 3 3 1-9h7v13h-1v-12h-5l-1 18-3-1-8-17-3-3 1-2-5-1z",
    fill: "#755EBF"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(840,760)",
    d: "m0 0v3l1 5 2 5 5 5 4 5v2l-9 2h-9v-3l2-2 1-4h2l-2-6-2-4v-3l2-1 1-3z",
    fill: "#716AD2"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1010,756)",
    d: "m0 0h6l4 2 4 7v2h-2l-2 4-4-1-14-7 2-4z",
    fill: "#154294"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1024,810)",
    d: "m0 0 9 2 11 3 2 6v5l-17-5-5 1v-3h2l-2-4z",
    fill: "#4881DF"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(495,866)",
    d: "m0 0 68 1 2 2-15 1h-25l-4 1-2 3v-2h-20v-1h13v-2h-20z",
    fill: "#4B77D2"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(630,830)",
    d: "m0 0 5 1 18 6-1 5-1 1h-8l-9-3-8-4 3-5z",
    fill: "#5647B6"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(800,152)",
    d: "m0 0 2 1-2 3h-2l-1 3-18 8-3 1 1 2-10 3-5 1 6-7 15-9 10-3z",
    fill: "#1D5BAE"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1022,768)",
    d: "m0 0h2v15l-5 9-2 3-4 1v-13l4-9z",
    fill: "#CDEAFA"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(833,731)",
    d: "m0 0 3 1-8 7-17 9-9 3h-7l-3-3 8-3 10-3 12-5z",
    fill: "#7D6AD3"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(957,348)",
    d: "m0 0 5 2 1 3 5-3 4-2 2 2-1 4-4 4h2v2l3 1-2 4-8-4-5 4-3-1v-4l3-2-1-3-3-2z",
    fill: "#81C7E1"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(888,920)",
    d: "m0 0 2 1-1 3 4 1 3 11 2 8h2l4 15-1 5h-2l-1 2-2-9-3-8-8-24z",
    fill: "#67B2EA"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(311,691)",
    d: "m0 0 3 1-1 5 4 2 3 3h-2v3h6l6 5v2h-2v2l4 2h-3v2h-2v-2h-2l-1-2-4-2v-2h-3v-3h-3v-2l-2-1h2v-2l-5-1-3-2v-6z",
    fill: "#F9FDFB"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(958,562)",
    d: "m0 0h6l2 1-2 4-11 9-4 4-2 3-1-7v-10z",
    fill: "#6CBAED"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(842,759)",
    d: "m0 0h1l2 6 8 14 7 12 1 4-7 12-3 3v-4h2l1-5 2-5v-6h-2l-5-10-4-5-3-2-3-7 1-4z",
    fill: "#72C1EC"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(451,826)",
    d: "m0 0h38v5h-38z",
    fill: "#F9FDFB"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(368,663)",
    d: "m0 0h12l-2 6-11 22-10 19h-2l1-5 3-6h2v-5h2l2-6 1-2h2l1-7 3-3 5-12-6 1-1 3h-2l-2 3v5l2 2-2 4-6 2-2 4-1-2 9-21z",
    fill: "#FEFEFE"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1332,471)",
    d: "m0 0h38v5h-38z",
    fill: "#6CBAED"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1258,471)",
    d: "m0 0h38v5h-38z",
    fill: "#6CBAED"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1184,471)",
    d: "m0 0h38v5h-38z",
    fill: "#6CBAED"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(792,260)",
    d: "m0 0h16l3 4-4-1-1 8-3 5-7-1v-5h2l-1-6h-9l-7 1 4-3z",
    fill: "#342E8E"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(692,778)",
    d: "m0 0 19 9 8 4 2 4-28-6-1-1z",
    fill: "#7A67D1"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(447,729)",
    d: "m0 0h1v13l-3 5h-2l-2 4-5 3-4 1h-51v23h-1v-24l-2-1 56-1 8-6 3-4z",
    fill: "#775BBC"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1046,760)",
    d: "m0 0h6l15 5-2 4-5 3-11-3-9-3 1-3z",
    fill: "#164093"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(709,382)",
    d: "m0 0 3 4 8 14 3 3v3h2l9 18-2 3-4-5-2-1-4-8-2-1-10-25z",
    fill: "#9480D8"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(909,182)",
    d: "m0 0 11 1 16 4v1h-8l-17-4 8 20 9 23 4-1-2 5h-4l-6-17-4-9-4-12-3-8z",
    fill: "#8F70CB"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(803,518)",
    d: "m0 0 17 1 15 2-1 2 2 2-2 1h-9l-1 8-2 1v-2h-2l1-9h-11l-1-3h-6zm15 15 2 1z",
    fill: "#725ABC"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(403,541)",
    d: "m0 0h7l10 24-1 4-6-13-4-9h-2l-3 1-1 2-5-2v4l-2 1-2 3-3-6 2-4 6-4z",
    fill: "#8671D6"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(839,710)",
    d: "m0 0h1v16l4 7 7 9 1 6-5 7h-2l2-4 1-3v-3h-2l-1-3-5-5-6-8-1-8 2-1 1 6h1z",
    fill: "#6EC2EE"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(799,531)",
    d: "m0 0h8l7 1v11h-14l-1-1z",
    fill: "#7259BB"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(351,699)",
    d: "m0 0 1 3v5l2 4 1 3-6 11h-8l-1-2z",
    fill: "#FDFDFD"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(476,384)",
    d: "m0 0h2l2 11v4l-9 1-5 2-1-5-1-4 9-7z",
    fill: "#FCA49B"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(791,309)",
    d: "m0 0h28l9 2v1h-22v3l2 3h-9l-9 3-1 3-4 4-1 2v9l1 3h-3l-2-8 1-2-3-1 3-1 4-7 4-2v-2l10-4 2-3-10-2z",
    fill: "#453D9F"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1087,158)",
    d: "m0 0h1l1 43 1 3h8v7l-4 2-12 1-2-2-1-21v-23h1l1 15v28l14-1 2-4-8-1-2-3-1-27v-16z",
    fill: "#77BCE7"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(583,603)",
    d: "m0 0h1l1 17 2 1 2 3 1 4h-2v3h-2v3h-2l-1 4h-2l-1 4-6 4 3-10 3-9h2z",
    fill: "#7966CF"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(540,838)",
    d: "m0 0h32v5h-18l-22-1 1-2z",
    fill: "#F5FBFB"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(624,572)",
    d: "m0 0 7 6 6 5 5 7h-3l-2-2-8 3-1 5v8h-1l-2-17z",
    fill: "#6F58BB"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(858,224)",
    d: "m0 0h1l1 7 1 2-3 11h-9l-3 3-2-1 4-10h2v-3h2l2-5z",
    fill: "#29328F"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(670,438)",
    d: "m0 0 7 1 4 3 3 10-1 3-3-1-3-3v3h-2l-1 4-4-11z",
    fill: "#937FD8"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(850,324)",
    d: "m0 0 3 2 3 10-1 9-8 19-2 5-6-1-1-3 2-5 4-2 4-5 3-7 1-7v-9z",
    fill: "#2F419E"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(841,313)",
    d: "m0 0 9 2 4 5v2h2v2l5-1-3 15-2 3-3-12-2-4-2 1-3-3-2-1-1-7z",
    fill: "#4670CB"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(487,787)",
    d: "m0 0h30l2 1v2h-68v-2z",
    fill: "#5567BA"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(450,643)",
    d: "m0 0h1v27l-2 53-1 6h-1v-22l2-62z",
    fill: "#A366B4"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(697,528)",
    d: "m0 0h15v11h-14z",
    fill: "#7846A2"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(943,488)",
    d: "m0 0h1l2 54v25l-2-2-1-12-1-27v-23z",
    fill: "#7A8AD4"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(919,481)",
    d: "m0 0h1l4 24 7 34v6h-1l-2-9-3-8-3-12-2-14-3-13 1-4z",
    fill: "#70C0EE"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(852,634)",
    d: "m0 0h1l-1 10-8 46h-1v-7h-2l1-8 3-14 6-26z",
    fill: "#74C4EE"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(407,536)",
    d: "m0 0 4 1-2 1-1 4-9 1-6 4-1 3 3 6-1 3-5-5-6-2-1-4h2l2-2h3l1-3 8-5z",
    fill: "#826CD3"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(782,187)",
    d: "m0 0h24l12 3 5 3v1l-17-1-15-2-9-3z",
    fill: "#467FE0"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1107,445)",
    d: "m0 0 6 2 4 5v5l-4 4-5 7h-1l-1-21z",
    fill: "#85C6DD"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(913,992)",
    d: "m0 0 2 4 6 34 1 24h-1l-7-36-1-7h2l-2-14z",
    fill: "#73C3EF"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(688,875)",
    d: "m0 0 5 1 6 4-2 1-8-4v18l-1 27v21l-1 23-1 6h-1l1-51 1-45z",
    fill: "#5643B2"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(578,481)",
    d: "m0 0 2 1 8 24-1 4-5-3-6-6 2-11z",
    fill: "#7C68D1"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(727,421)",
    d: "m0 0 5 4 3-1 2 5h2l7 8 9 7 3 3v3l-5-1-10-9-15-15z",
    fill: "#8970D3"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(703,371)",
    d: "m0 0h5l-1 8h2l1 7 4 9 6 13v4l3 1 3 5v6l-4-4-3-7v-3h-2l-7-16-7-21z",
    fill: "#7C67D1"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(451,791)",
    d: "m0 0h31l5 2v2h-36z",
    fill: "#F9FDFB"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(944,584)",
    d: "m0 0h1v9l-5 4-7 9-9 12 1-5 6-12 10-14z",
    fill: "#846ED6"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(859,848)",
    d: "m0 0h1l2 7-1 7-2-2v-3l-5 2-6-1-1 2-1-1h-6l-1-3 13-5 7-1z",
    fill: "#5235A3"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(784,525)",
    d: "m0 0h5v23h-6v-21z",
    fill: "#FEFEFE"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(879,620)",
    d: "m0 0 8 2v12 3l1 2v8l-2-4h-2l-1-7h-2l-2-8v-5z",
    fill: "#735DBF"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(537,272)",
    d: "m0 0m-1 1 1 3-2 2 8 6v2l3 1-1 5-3 4-4-2-6-4v-2l-4-2-4-3 7-2v3l5 1 1 5h7l-1-2-6-1v-3h-2l-2-5 1-4z",
    fill: "#FDF7FD"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(450,802)",
    d: "m0 0h1v6h67l-5 4h-19l1-3h-45z",
    fill: "#5E77D6"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(460,797)",
    d: "m0 0h58v1l-19 1 19 1v1h-64v-1h39v-2h-33z",
    fill: "#5567BA"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(812,302)",
    d: "m0 0h11l21 3v1h-6l1 3-7 1-16-4z",
    fill: "#B365AB"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1062,220)",
    d: "m0 0 1 2h10l2 1 94 1v1h-110l3-2z",
    fill: "#6098DA"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(770,927)",
    d: "m0 0h2l4 9-1 4h-3l3 6-2 2-5-1-3-11 1-4 2-4z",
    fill: "#45278D"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(884,900)",
    d: "m0 0 2 3 10 26 5 14-1 4v-3h-2l-4-10-2-9-3-1-1-4-1 3-2-9v-6l-2-5z",
    fill: "#70C2EF"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(688,802)",
    d: "m0 0h1v6h2v38l-1 3-1 26h-1l-1-5v-23l1-16z",
    fill: "#5A4AB6"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1100,370)",
    d: "m0 0 2 1-3 10-4 3h-8l1 5-1 8h-1v-14l4-6 7-6z",
    fill: "#F5FBFB"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(673,984)",
    d: "m0 0h2l-1 3h-91l1 3-4 2-2-1-1 4 1-8 1-1 90-1z",
    fill: "#5746B4"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(900,464)",
    d: "m0 0 4 1 6 4 5 4 1 3 3 1v8l-3 1v-3h-2l-6-8-4-3v-2l-3-1z",
    fill: "#5EBBEB"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(491,920)",
    d: "m0 0h32l2 4h-36z",
    fill: "#FEFEFE"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(729,529)",
    d: "m0 0h14v3h5l-4 5h3v2l2 1h-20l1-4 10 1v-5h-11z",
    fill: "#7648A5"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(788,263)",
    d: "m0 0h10l-1 6-3 1-1 4-9-3-5-4z",
    fill: "#F1EFFB"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1133,152)",
    d: "m0 0h10v1l-7 1-1 3h9l2 2v26l-1 18h-1l-1-42-8-1-2-2z",
    fill: "#66C1E5"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(722,439)",
    d: "m0 0 5 4 13 13 7 5v2h-6l-13-12-7-9z",
    fill: "#7059BB"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1152,898)",
    d: "m0 0 6 1 21-1 1 5h-30l2-1v-2l-3-1z",
    fill: "#F9FDFB"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(722,267)",
    d: "m0 0h2l3 7v4l-4 2-1 2-4 2-2 2v-10l3-6z",
    fill: "#B164AC"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(838,155)",
    d: "m0 0h12v3l-9 2-2 1-29 1 1-2 12-1 5-2z",
    fill: "#4081D1"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(386,470)",
    d: "m0 0 10 5 12 11 5 7-1 2-3-3v-2l-4-2-5-4-2-1v-2l-4-1-6-3z",
    fill: "#AF98EB"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(384,927)",
    d: "m0 0h1l1 24h1l1 21 2 4 5 5 5 3 4 1v2l-6-1-6-4-6-7-2-11z",
    fill: "#7376D2"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(576,473)",
    d: "m0 0 2 1 1 7v10l-2 8h-3l-2-3 2-16z",
    fill: "#816BD4"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1102,411)",
    d: "m0 0h4v17h-9l-5-1 4-2 6-12z",
    fill: "#6EBAEB"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(536,862)",
    d: "m0 0h28v4h-29z",
    fill: "#F9FDFB"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(695,672)",
    d: "m0 0 8 6 8 7-1 4-10-2-4-5 1-6-4-3z",
    fill: "#8A70D4"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(698,404)",
    d: "m0 0 4 5 6 10 10 14 4 4-1 5-5-5-7-10-6-10-5-10z",
    fill: "#7865D0"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(819,224)",
    d: "m0 0 1 2-3 5-1 1-30 1-8 3-6 2 1-4 6-3 9-1 26-1z",
    fill: "#552E90"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(486,777)",
    d: "m0 0h26l3 3v1h-26l-4-2z",
    fill: "#F9FDFB"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(451,777)",
    d: "m0 0h26l3 3-1 1h-28z",
    fill: "#F9FDFB"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(942,569)",
    d: "m0 0v3l-12 21-9 19-1-3 4-12 7-13 6-9 1-3h2v-2z",
    fill: "#907CDA"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(350,487)",
    d: "m0 0 2 1 1 3 3 2h-3l-1 11v19l-2-3-2-8v-16z",
    fill: "#B099EB"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(459,809)",
    d: "m0 0h36l-1 3h-35z",
    fill: "#506DC8"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(442,624)",
    d: "m0 0 5 2 3 3v8l2 4-1 3-5-8-6-5-5-2v-2z",
    fill: "#E8F4FD"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(790,770)",
    d: "m0 0 3 1-2 1 3 2v2l3 1h-22v-1l-5-1v-2z",
    fill: "#826DD7"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(744,777)",
    d: "m0 0h11l15 1v5l-7 1-14-4-5-2z",
    fill: "#9483E9"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1206,814)",
    d: "m0 0 5 1 2 2h-5l2 6 1 4-2 3-1 7v13l1 3 2 2-5 2z",
    fill: "#C2B1F0"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(817,341)",
    d: "m0 0 3 1 1 1h7l1 5h-4v-3l-4 3h-2l-3 4h-2l-2-2-6 7-2-2 1-2-3-1h5v-2l6-4z",
    fill: "#343292"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(451,803)",
    d: "m0 0h19l2 1 11 1-1 2h-31z",
    fill: "#F9FDFB"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 542)",
    d: "m0 0 7 1v2l5 2 3 3-5-2h-2l-2 2 1 3h-2l1 4-4-1-1-2-2 3v-8z",
    fill: "#5C9BDE"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(727,274)",
    d: "m0 0 2 2v5h-5l-1 12-4 1-4-6v-11h1l1 7 2-2h3l2-4h3z",
    fill: "#E67BA1"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(583,987)",
    d: "m0 0h21v1l-11 1v3l2 1v2h-8v-2l-7 1-2-1v-2l5-1z",
    fill: "#6251BA"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(807,531)",
    d: "m0 0h8v2l5-1 4 2v15h5v-14h1v15h-7l-1-10-1 9h-1v-12h-5v6h-1v-11h-7z",
    fill: "#947DD7"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(805,318)",
    d: "m0 0 5 1 9 4h25l-4 4-3 1h-9l-14-4-9-5z",
    fill: "#EAA4AE"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(901,947)",
    d: "m0 0 2 3 8 29v5l-3-3-2-9-1-5-1 9h-1l-2-6v-6l2-1-1-6z",
    fill: "#73C3EF"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(848,269)",
    d: "m0 0h6l3 3h-4l-1 9-2 3h-4v-5h2l-1-5 1-2-8 1 4-3z",
    fill: "#381E81"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(828,314)",
    d: "m0 0h9l4 1v6l-3 1h-9l-1-1z",
    fill: "#467FE0"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(451,826)",
    d: "m0 0h21l-2 2-5 1h7v2h-21z",
    fill: "#F9FDFB"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(878,886)",
    d: "m0 0 2 3 4 9-1 7 2 1 1 2v6l-3-1-6-18z",
    fill: "#6DC1EE"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(458,855)",
    d: "m0 0 4 1 25 1h8l-1 2-38 1-4-1 1-3z",
    fill: "#497CDC"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(556,814)",
    d: "m0 0 4 1v4h-26l-2-3 6-1h17z",
    fill: "#23ce6b"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1117,782)",
    d: "m0 0 2 2-4 8v37h-2l-1-5v-31l4-9z",
    fill: "#AF6DBA"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(877,537)",
    d: "m0 0h1v12l-1 14 6-1 1-19h1v24l-8-1-1 10h-1v-12z",
    fill: "#654AB1"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(451,920)",
    d: "m0 0h18l1 4-1 1h-18z",
    fill: "#23ce6b"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(451,885)",
    d: "m0 0h18l1 5h-19z",
    fill: "#F2FAFB"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(503,838)",
    d: "m0 0h37l-2 2-6 1h-20l-9-2z",
    fill: "#FEFEFE"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(549,497)",
    d: "m0 0 3 4 2 5 3 19h-2v-3l-4-1-2-19z",
    fill: "#8978DE"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1087,397)",
    d: "m0 0 7 1 2 4 3 1 2 4v3l-5-1-7-6z",
    fill: "#F6FBFB"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(860,182)",
    d: "m0 0h3l4 5 3 5 2 3-1 3-4 1-3-1-2-10-2-2z",
    fill: "#3F7ED4"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(234,563)",
    d: "m0 0h5v5l-9 1h-19l-1 2v-6l8 1 14-1z",
    fill: "#8879E1"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(709,264)",
    d: "m0 0 6 1 4 4-2 7-1-3-7 2-1-9z",
    fill: "#FBA19A"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1316,776)",
    d: "m0 0 6 1 7 8 3 8v15l-1 10h-1l-1-25-4-9-6-5z",
    fill: "#AC65B0"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(416,628)",
    d: "m0 0h17l9 3 7 7 1 7-2-1-2-5-5-5-7-3-27-1v-1z",
    fill: "#955EB3"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1144,151)",
    d: "m0 0h10l-1 32-1 30-4-1 2-2 2-58h-8z",
    fill: "#7AD2F4"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(731,899)",
    d: "m0 0 2 1-2 3-5 4h-2l-2 6-10 21-3 7h-2l3-9 7-15 6-11z",
    fill: "#6A53BB"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(765,737)",
    d: "m0 0 4 1v4l2 1h-24l2-2z",
    fill: "#9483E9"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1065,391)",
    d: "m0 0 3 1 4 15 6 9-1 3-5-5-5-9z",
    fill: "#7FDAF6"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(844,372)",
    d: "m0 0 3 1-2 5-9 11-4 3-3-1 8-10 4-7z",
    fill: "#6DBBED"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(565,295)",
    d: "m0 0 2 1v11l1 1v2h-19l-13-1v-2h27z",
    fill: "#B972E5"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(406,708)",
    d: "m0 0 3 1-10 9-9 7h-1v-14l3-1-1 5 1 2 5-1v-3l8-3z",
    fill: "#FDFCFD"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(728,529)",
    d: "m0 0 1 3h11v5h-10l-1 3h18v1h-19z",
    fill: "#A590E7"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(233,572)",
    d: "m0 0 2 4-5 2-7 3-7-6 4-2h10z",
    fill: "#3F8CEE"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(526,814)",
    d: "m0 0h30l-2 2h-17l-4 1 1 2h-10z",
    fill: "#FEFEFE"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(848,748)",
    d: "m0 0v3l-4 5-2 4-4 1v3l-4-2v-2l-4 1v-2l13-7z",
    fill: "#6355BD"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(419,630)",
    d: "m0 0h13l-1 7h-11l-1 4z",
    fill: "#F17BF5"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(386,549)",
    d: "m0 0 1 4 5 1 1 4-1 5 5 9v3h-2l-11-21z",
    fill: "#9381E3"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(779,527)",
    d: "m0 0 1 4-4 2 1 2-10-1-8-2 1-4 14 1 1 2 3-1z",
    fill: "#967FDB"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(685,724)",
    d: "m0 0 4 1 18 11 3 2-1 4-2-1-5-4-6-2v-2l-4-2-3-1z",
    fill: "#8A71D5"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(409,528)",
    d: "m0 0 3 1 1 8-16 1 5-5z",
    fill: "#725ABC"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(573,437)",
    d: "m0 0h1v13l-1-3h-2l-1 9-2 2-1-1-2 5-1-4 6-17z",
    fill: "#9987E4"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1105,471)",
    d: "m0 0h2l-2 5-5 4 1 6-4 1-11-7 2-1 6 1 6-4z",
    fill: "#6DA2D7"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(703,257)",
    d: "m0 0 10 1 2 3-5 2h-2l-1 5-3 1-1-5z",
    fill: "#B164AC"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(537,867)",
    d: "m0 0h26l2 2-15 1-25-1v-1z",
    fill: "#4D75CE"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(529,451)",
    d: "m0 0 1 3-9 19-1-3 1-9-2-1z",
    fill: "#B468AD"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(899,963)",
    d: "m0 0 2 3 3 10 2 12h-2l-1-3h-2v-3h-2l-1-6h3l1-4h-3l-1-6z",
    fill: "#514FBA"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(980,810)",
    d: "m0 0 3 1 4 6v2h-12l-2-2 5-5h2z",
    fill: "#1B5DB0"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(836,701)",
    d: "m0 0h1l1 25h-3l-1-5h-1l2-18z",
    fill: "#50A9E5"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(792,260)",
    d: "m0 0h16l3 4h-23l-7 1 4-3z",
    fill: "#3F2183"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(987,817)",
    d: "m0 0 2 3-4 7 1 3 4 1 4 2 3-6 1 4-1 5-10-3-5-2 1-6 2-5h-5v-1h7z",
    fill: "#62A6E3"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(738,579)",
    d: "m0 0h36v1l-28 2h-14v-1z",
    fill: "#8B73D6"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1168,744)",
    d: "m0 0 7 2h6l2-1-1 4-3 3h-6l-4-2z",
    fill: "#7B48A3"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(582,600)",
    d: "m0 0h1v21l-1 6h-2v-25z",
    fill: "#8778E0"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(620,568)",
    d: "m0 0 4 3 2 16v12h-1l-4-24-1-2-2 1z",
    fill: "#AC98EA"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1114,371)",
    d: "m0 0 5 2 2 5v9l-6-5-1-2z",
    fill: "#F6FBFB"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(938,350)",
    d: "m0 0 2 3-1 35-2-4v-32z",
    fill: "#7A71CA"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(730,902)",
    d: "m0 0h1l-1 7-3 12-2 1v-7l-2-3 1-5z",
    fill: "#3A1E81"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(635,716)",
    d: "m0 0 1 2 2 1-4 5-3 8h-5l1-6z",
    fill: "#9986E3"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(855,237)",
    d: "m0 0h4l-1 7h-9l-3 3-2-1 4-8 3 1z",
    fill: "#412485"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(847,526)",
    d: "m0 0h7v13h-1v-12h-5l-1 18-3-1-3-6v-2l5-1z",
    fill: "#8C74D1"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1081,357)",
    d: "m0 0 2 1-4 6-5 7h20v1h-21l-3-2 6-8z",
    fill: "#74C5EF"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(505,264)",
    d: "m0 0 1 3 3 1v2h2l1 2 5 3 1 7-3-1v2l-3 2-4-1 7-6 1-2-5-2-9-7z",
    fill: "#FEFEFE"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(773,355)",
    d: "m0 0 7 1 4 2v5h6v1h-11l-5-3 2-1v-4z",
    fill: "#5747B6"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(305,693)",
    d: "m0 0 2 2-1 4 4 2 4 1v5h3l1 4-4-2-13-11z",
    fill: "#FEFEFE"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(643,564)",
    d: "m0 0 3 1-9 3-13 4-3-3v-2z",
    fill: "#5132A2"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(791,309)",
    d: "m0 0h28l9 2v1h-27l-10-2z",
    fill: "#503F9D"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(478,791)",
    d: "m0 0 8 1 1 3h-21l-1-3z",
    fill: "#FEFEFE"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1064,751)",
    d: "m0 0 2 2 2 9-1 4-19-6 1-2 5 1 10 4z",
    fill: "#2366B9"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(508,257)",
    d: "m0 0h3l5 5 8 6 1 3-3 1-3-1v-2l-3-1v-4h-4v-2h-4l-2-1z",
    fill: "#FDF8FD"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1006,727)",
    d: "m0 0 5 1 6 4-1 3-8 2z",
    fill: "#256FD1"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(358,490)",
    d: "m0 0h3l2 5v5h-3l-2-2-2 1-1-1-1 2-1-1v-6h3v-2z",
    fill: "#7A64C5"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(786,191)",
    d: "m0 0 13 1 1 3h-9l-26-2v-1z",
    fill: "#36328F"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(806,721)",
    d: "m0 0h2l1 3-1 7 5 2-2 2-6 2-4-1 4-5v-5l-2-1 1-3z",
    fill: "#8A71D4"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(692,981)",
    d: "m0 0 1 4-9 29-2 3 1-9 5-16z",
    fill: "#7863CC"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(386,477)",
    d: "m0 0 6 1 3 3-6-1-1 6 1 4h-2l-5-9v-2z",
    fill: "#7E67C7"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1080,456)",
    d: "m0 0h4l1 2 2-2 3 1-9 9-4-2 2-6z",
    fill: "#75C4ED"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(936,188)",
    d: "m0 0h8l14 3-1 5-5 4 2-4 2-3-9-1-11-3z",
    fill: "#8F72CE"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(803,403)",
    d: "m0 0 2 4v4l-5 15 1 2h-3l2-15z",
    fill: "#735DC1"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(797,268)",
    d: "m0 0 1 2h-2v5h7l2-1-1 5-11-2-5-2v-1h5l1-5z",
    fill: "#A872C0"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(920,211)",
    d: "m0 0 3 3 5 13 4-1-2 5h-4l-6-17z",
    fill: "#9072CD"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(890,924)",
    d: "m0 0 3 1 3 11 3 8v3h-3l-3-8-2-9-1-1z",
    fill: "#18B4E0"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(662,733)",
    d: "m0 0h16l8 5 4 5-1 3-1-4h-2l-4-4h-4v-2l-16-2z",
    fill: "#573BA8"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(780,527)",
    d: "m0 0 2 2v19l-3-1v-10l-2-1v-2l-2-1 4-2z",
    fill: "#724AA9"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(915,483)",
    d: "m0 0 2 3 2 6 2 10 1 10h-2l-2-9-1-12h-2v7h-1v-8z",
    fill: "#566DC6"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(858,185)",
    d: "m0 0h1v7l-5 12-3 3 4-18 1-3z",
    fill: "#4CA4E5"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(822 1e3)",
    d: "m0 0 2 3 2 5-1 3h-4l-3-3v5l-2-4 2-5z",
    fill: "#5C3FA7"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(889,639)",
    d: "m0 0 4 1v9l-1 4h-3l-2-6z",
    fill: "#8572D9"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(859,166)",
    d: "m0 0 2 4 1 12h-2v6l-4-2v-6l2-1 1-9-2-1z",
    fill: "#6BB8EC"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(842,759)",
    d: "m0 0h1l2 6 1 6-3 3-4-8 1-4z",
    fill: "#69BAEC"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(701,681)",
    d: "m0 0 4 1 6 5-2 2-9-2-3-4z",
    fill: "#8879E1"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(816,355)",
    d: "m0 0 3 3v2h-2v3h-8l-1-2 4-5z",
    fill: "#2A328F"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(364,672)",
    d: "m0 0 2 4 2 2-2 4-6 2-2 4-1-2 5-12z",
    fill: "#FEFEFE"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(529,467)",
    d: "m0 0h1v27h-1l-1-16-5 2 2-5z",
    fill: "#8979E0"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1188,572)",
    d: "m0 0h17l-1 3h-19z",
    fill: "#7FD9F6"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(924,520)",
    d: "m0 0h3l4 19v6h-1l-2-9-3-8z",
    fill: "#76C6EF"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(563,462)",
    d: "m0 0 3 3-2 12-2 4-2-3 1-8z",
    fill: "#9B87DD"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1173,735)",
    d: "m0 0h6l4 4-5 2h-5l-2-2v-3z",
    fill: "#765DBF"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(814,406)",
    d: "m0 0 5 5 11 8 5 4-6-1-9-7-4-2-2-3z",
    fill: "#9684E3"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(390,668)",
    d: "m0 0 4 2 4 4 1 3-5 2-3-2 3-2v-2l-5 1-1-2z",
    fill: "#F9FDFB"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(799,192)",
    d: "m0 0 25 1 1 2h-25z",
    fill: "#154EA1"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(904,965)",
    d: "m0 0 2 2 2 12 2 6-2 3-3-10-1-1z",
    fill: "#18B4E0"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1207,814)",
    d: "m0 0 6 2v1h-5l2 6 1 4-2 3-1 7h-1z",
    fill: "#FEFEFE"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(738,515)",
    d: "m0 0h24v1l-17 1-4 3-3-1-4-2z",
    fill: "#7557B8"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(919,1043)",
    d: "m0 0h1l2 11 1 1 1 11-3-1-1-5v-11h-2v-5z",
    fill: "#5975C8"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(581,993)",
    d: "m0 0h6v2h5l-2 4-5 1-2-2-2-1z",
    fill: "#6D4EB0"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(931,601)",
    d: "m0 0h5l-2 4-7 9-3 4 1-5z",
    fill: "#8979E0"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1092,351)",
    d: "m0 0 3 1-4 4-8 5h-2l2-5 7-4z",
    fill: "#77CAF1"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1082,150)",
    d: "m0 0h14l2 3-1 5h-9v-1l9-1-1-2-14-3z",
    fill: "#48B3DE"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(449,801)",
    d: "m0 0 2 1-1 7h9v3l-9 1v-2l-2-1v-8z",
    fill: "#516CC5"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(796,746)",
    d: "m0 0h7l1 2-2 3h-7l-3-3z",
    fill: "#7C68D2"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(397,545)",
    d: "m0 0 2 1-1 6-2 1-2 3-3-6 2-4z",
    fill: "#87d"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(907,467)",
    d: "m0 0 8 6 2 4v5l-5-5-3-5v-2h-3z",
    fill: "#18B4E0"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(829,820)",
    d: "m0 0h6l-1 2-14 3h-5l1-3z",
    fill: "#836FD7"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(879,516)",
    d: "m0 0 2 2 3 12-5 2z",
    fill: "#6345AB"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(785,323)",
    d: "m0 0 3 1-4 6v9l1 3h-3l-2-8 1-2-3-1 3-1z",
    fill: "#373391"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(808,318)",
    d: "m0 0 5 1 12 3 11 1v1h-17l-9-4z",
    fill: "#3C3392"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(899,948)",
    d: "m0 0 2 2 3 9-1 5h-2l-1-8-2-1-1-6z",
    fill: "#18B4E0"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(459,826)",
    d: "m0 0h13l-2 2-5 1h7v2h-9l-2-2 1-2z",
    fill: "#FEFEFE"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1007,820)",
    d: "m0 0h3v7l-10-3v-2z",
    fill: "#144294"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(846,522)",
    d: "m0 0h7v4h-6v7l-1 2-3-1v-2l2-1v-7z",
    fill: "#6C54B8"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(962,473)",
    d: "m0 0 2 3 3 7-1 3-1-1-2 5h-1l-1-15z",
    fill: "#78C9EF"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(465,803)",
    d: "m0 0 7 1 11 1v1h-26l4-2z",
    fill: "#FEFEFE"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(364,692)",
    d: "m0 0 1 3-8 15h-2l1-5 3-6h2v-5z",
    fill: "#FDF8FD"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(402,539)",
    d: "m0 0h7l-1 3-9 1-6 4-4 2 1-3 9-6z",
    fill: "#6548AE"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(862,864)",
    d: "m0 0 5 3v6l-5-1-2-6h2z",
    fill: "#4F35A4"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(400,678)",
    d: "m0 0 3 2v2l2 1h-3l4 4v5l-4-4v-2l-4-2v-3h2z",
    fill: "#F9FDFB"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(486,627)",
    d: "m0 0 2 3 3 8 1 4 1 2-2 2-6-14z",
    fill: "#AC95E8"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(580,627)",
    d: "m0 0 1 4-1 7v4l-6 4 3-10z",
    fill: "#7F6FD4"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(759,529)",
    d: "m0 0 14 1v3h-8l-6-1z",
    fill: "#764DAB"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(820,343)",
    d: "m0 0h8l1 5h-4v-3l-4 3-4 1-1-4z",
    fill: "#4F43AF"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(752,302)",
    d: "m0 0 3 1 3 4v2l4 2 2 3-4-1-5-3v-3h-3z",
    fill: "#3E308F"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(540,272)",
    d: "m0 0 1 3h-3v3l4 3v2l4 2v3l-3-2v-2l-4-2-5-5 3-1v-2z",
    fill: "#C279B8"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(843,269)",
    d: "m0 0h5l-4 2v1h4l-1 5h-3v-3l-7 1v-3z",
    fill: "#9363B7"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(914,193)",
    d: "m0 0 2 3 5 13-2 4-6-18z",
    fill: "#9579D3"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(703,371)",
    d: "m0 0h5l-1 8h2v7l-2-1-4-12z",
    fill: "#7E6AD1"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(565,295)",
    d: "m0 0 2 1v11l-2 2-4-1 2-1z",
    fill: "#C057E0"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(847,277)",
    d: "m0 0 1 2h-2v5l4-1 2-2v3l-1 2-9-2-1-2h2v-4z",
    fill: "#A76CBA"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(911,998)",
    d: "m0 0 3 4 1 9-3-1-2-5z",
    fill: "#3FADE3"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(671,986)",
    d: "m0 0h3l-1 4h-9l-6-2v-1z",
    fill: "#6252BB"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(906,965)",
    d: "m0 0 2 4 3 10v5l-3-3-2-9z",
    fill: "#74C6F0"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(888,920)",
    d: "m0 0 2 1 1 8 2 3v8l-2-3-4-12z",
    fill: "#5AABE7"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(451,814)",
    d: "m0 0 10 2 2 3h-12z",
    fill: "#23ce6b"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(447,729)",
    d: "m0 0h1v13l-3 5h-2l-1 3-3-1 6-7z",
    fill: "#714DAC"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(414,542)",
    d: "m0 0 3 1 4 11-4-2-3-5z",
    fill: "#FAFCFC"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(573,437)",
    d: "m0 0h1v13l-1-3-4-1 1-5z",
    fill: "#9380DF"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(836,278)",
    d: "m0 0 4 2 3 2-1 1 6 2-2 1-1 3-4-1-3-7z",
    fill: "#ED8FA1"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(895,929)",
    d: "m0 0 2 3 4 11-1 4v-3h-2l-4-10z",
    fill: "#76CAF2"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(527,803)",
    d: "m0 0h9l1 3-1 1h-9z",
    fill: "#FAFDFB"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(753,711)",
    d: "m0 0 14 5v1l-10-1-8-2z",
    fill: "#8972D5"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(729,533)",
    d: "m0 0h10v4h-9z",
    fill: "#F9F8FD"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(785,310)",
    d: "m0 0 4 1h-3v2l-8 4h-4l1-3h4v-2z",
    fill: "#5849A6"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(904,977)",
    d: "m0 0 2 1 2 10h2l-1 8-2-4-3-12z",
    fill: "#55A7E6"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(416,694)",
    d: "m0 0 5 5-11 9-1-3 7-5h2z",
    fill: "#FEFEFE"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(863,598)",
    d: "m0 0h3l-2 5-4 6-3 1-1-3 4-3 1-4z",
    fill: "#9280E3"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(718,409)",
    d: "m0 0h2v3l3 1 3 5v6l-4-4z",
    fill: "#7863CB"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1129,774)",
    d: "m0 0h5l-2 2-14 7 2-4 6-4z",
    fill: "#A15FB1"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(709,247)",
    d: "m0 0 9 1 4 2v2l-12-2-4 1 1-3z",
    fill: "#EF91A1"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(844,154)",
    d: "m0 0h8l6 7 1 4-2-1v-2l-4-1-3-5-6-1z",
    fill: "#74C1EB"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(632,722)",
    d: "m0 0 1 4-2 6h-5v-4l4-2z",
    fill: "#8F7DDE"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(413,551)",
    d: "m0 0 3 4 4 10-1 4-6-13z",
    fill: "#8979DE"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1396,337)",
    d: "m0 0 5 1 6 5 3 5v2h-2l-4-7-8-4z",
    fill: "#7473CD"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(848,238)",
    d: "m0 0 5 1-2 4-5 4-2-1z",
    fill: "#3E2085"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(858,224)",
    d: "m0 0 1 4-6 7h-2l-1 3h-2v-2h2v-3h2l2-5z",
    fill: "#4C3090"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(921,184)",
    d: "m0 0 9 1 6 2v1h-8l-9-2z",
    fill: "#9479D3"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1120,917)",
    d: "m0 0h2l3 5 8 5 2 1-1 2-8-4-5-4z",
    fill: "#B26DBB"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(744,708)",
    d: "m0 0 6 1 3 3-1 1h-6l-3-3z",
    fill: "#836DD6"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(573,644)",
    d: "m0 0 3 1-2 4-7 7-2-1 1-3 5-2v-3h2z",
    fill: "#9280E0"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(799,531)",
    d: "m0 0 2 1 1 4v4l3 1v1h-6z",
    fill: "#775ABB"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(882,902)",
    d: "m0 0 1 3 2 1 1 2v6l-3-1-2-8z",
    fill: "#43B4E5"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(997,827)",
    d: "m0 0 1 4-1 5-10-3v-3l5 2h3z",
    fill: "#538EDF"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(518,814)",
    d: "m0 0h8l-2 5h-5z",
    fill: "#F6FBFD"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(389,662)",
    d: "m0 0 5 5 4 5h-3l-5-4-2-1z",
    fill: "#FDFDFD"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(634,622)",
    d: "m0 0 3 1 2 4-2 7h-2z",
    fill: "#9282E8"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(860,325)",
    d: "m0 0h1v9l-2 10-2-3 2-12z",
    fill: "#70BEEC"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1057,137)",
    d: "m0 0h1v12l-3-1v-9z",
    fill: "#1D66C9"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(915,1023)",
    d: "m0 0 2 4 2 10-1 4-2-2z",
    fill: "#5173CB"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(806,855)",
    d: "m0 0h6v2l-9 3-4-1z",
    fill: "#5537A3"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1017,834)",
    d: "m0 0 1 4-2 4-9-2 3-2h5z",
    fill: "#3152A5"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(804,521)",
    d: "m0 0h5l1 2 11 1v1h-14l-4-2z",
    fill: "#6F4EAF"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1079,418)",
    d: "m0 0 4 2v2h3v2l6 2 1 2-5-1-10-7z",
    fill: "#82DEF7"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(778,231)",
    d: "m0 0 5 1-1 2-8 4h-2l1-4z",
    fill: "#512C8D"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(525,862)",
    d: "m0 0h11v3h-8l-3-1z",
    fill: "#FEFEFE"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(278,736)",
    d: "m0 0h2l3 9 3 3v2l-4-2-4-8z",
    fill: "#AB69B5"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(589,624)",
    d: "m0 0 1 4h-2v3h-2v3l-3 1-1-2 2-1v-5z",
    fill: "#7464C3"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(407,536)",
    d: "m0 0 4 1-2 2-13 2 2-3z",
    fill: "#8976D9"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(524,284)",
    d: "m0 0 5 2 3 2v2l5 2 2 3-5-2-8-6-3-2z",
    fill: "#B371B8"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(789,224)",
    d: "m0 0h8l-3 2-10 3-4-1z",
    fill: "#5B3292"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(820,217)",
    d: "m0 0h3l-2 7h-2v-3h-5l1-2z",
    fill: "#432388"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1080,199)",
    d: "m0 0h1v12l12 1v1l-11 1-2-2z",
    fill: "#5491E0"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(806,721)",
    d: "m0 0h2l1 3-2 7h-1l-1-5-2-1 1-3z",
    fill: "#8A6FD3"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(395,557)",
    d: "m0 0 3 4 3 9-4-4-3-5z",
    fill: "#8778E0"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(505,264)",
    d: "m0 0 1 3 3 1v2h2l2 4-4-2-7-5z",
    fill: "#FDF2FD"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(669,989)",
    d: "m0 0h4v5l-5 1-1-5z",
    fill: "#6E4EAF"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(891,937)",
    d: "m0 0 3 4 2 8-1 4-2-2-1-9z",
    fill: "#4E5BC1"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(843,854)",
    d: "m0 0 4 1 1 5-7-1-2-3z",
    fill: "#5032A2"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(471,527)",
    d: "m0 0 7 6 3 3h-5l-5-5z",
    fill: "#9380DB"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(598,524)",
    d: "m0 0 4 2 6 5h-3-5z",
    fill: "#6247AF"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(919,481)",
    d: "m0 0h1l1 13h-2l-2-5 1-4z",
    fill: "#75C7EF"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(699,375)",
    d: "m0 0 1 3-3 3-2 4-6 4-1-2 5-4z",
    fill: "#9B88E5"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(853,333)",
    d: "m0 0h1v10l-2 6-1 2h-2l2-5z",
    fill: "#604AA8"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(852,283)",
    d: "m0 0h2l1 7-4 1v-4l-3-1h3z",
    fill: "#F99D9A"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1151,191)",
    d: "m0 0h1v22l-4-1 2-2z",
    fill: "#6DB1E2"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(863,856)",
    d: "m0 0 4 5 3 6-1 2-3-2-3-8z",
    fill: "#75C5EE"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1316,776)",
    d: "m0 0 6 1 5 5v2l-4-2-7-5z",
    fill: "#A56DBC"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(441,632)",
    d: "m0 0 4 2 4 4 1 7-2-1-2-5-5-5z",
    fill: "#965BAD"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(801,531)",
    d: "m0 0 13 1v2l-7 1-5-2-2 1z",
    fill: "#704CAC"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(981,470)",
    d: "m0 0 2 3 7 8 1 2-5-2-1-3-3-1z",
    fill: "#83CFE7"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(848,748)",
    d: "m0 0v3l-4 5-2 3-1-4v-2z",
    fill: "#5D63C2"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(702,734)",
    d: "m0 0 8 3-1 5-2-1-5-4-2-2z",
    fill: "#876ED5"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(434,641)",
    d: "m0 0 4 1 3 4-2 2-7-5z",
    fill: "#F17BF5"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(935,595)",
    d: "m0 0 1 2 3 1-4 4-3 1 1-5z",
    fill: "#8A71D5"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(210,565)",
    d: "m0 0 6 1 2 1v2h-7l-1 2z",
    fill: "#8C7CE2"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(583,500)",
    d: "m0 0h2l3 6-1 4v-2l-4-2z",
    fill: "#735CBF"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(809,349)",
    d: "m0 0 3 1-6 7-2-2 1-2-3-1h5v-2z",
    fill: "#3E3997"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1215,833)",
    d: "m0 0 5 1-1 3-3 1z",
    fill: "#FEFEFE"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1082,939)",
    d: "m0 0h2l-2 4-3 2 2-5z",
    fill: "#A792E9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.4286e906be15682cc0c03b0482b87a97.svg";
export { ForwardRef as ReactComponent };